import React from "react";

const RemixIconsInner = () => {
  return (
    <section className='section'>
      <p>
        Use the following pattern to add the Remix icons to anywhere in your
        project.{" "}
        <code>
          &lt;i class="<strong>ri-add-line</strong>"&gt;&lt;/i&gt;
        </code>{" "}
        Replace the bold part with the below icon names. Check the{" "}
        <a href='https://remixicon.com/' target='_blank'>
          Official website
        </a>{" "}
        for more info.
      </p>
      <div className='iconslist'>
        <div className='icon'>
          <i className='ri-24-hours-fill' />
          <div className='label'>ri-24-hours-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-24-hours-line' />
          <div className='label'>ri-24-hours-line</div>
        </div>
        <div className='icon'>
          <i className='ri-4k-fill' />
          <div className='label'>ri-4k-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-4k-line' />
          <div className='label'>ri-4k-line</div>
        </div>
        <div className='icon'>
          <i className='ri-a-b' />
          <div className='label'>ri-a-b</div>
        </div>
        <div className='icon'>
          <i className='ri-account-box-fill' />
          <div className='label'>ri-account-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-account-box-line' />
          <div className='label'>ri-account-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-account-circle-fill' />
          <div className='label'>ri-account-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-account-circle-line' />
          <div className='label'>ri-account-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-account-pin-box-fill' />
          <div className='label'>ri-account-pin-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-account-pin-box-line' />
          <div className='label'>ri-account-pin-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-account-pin-circle-fill' />
          <div className='label'>ri-account-pin-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-account-pin-circle-line' />
          <div className='label'>ri-account-pin-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-add-box-fill' />
          <div className='label'>ri-add-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-add-box-line' />
          <div className='label'>ri-add-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-add-circle-fill' />
          <div className='label'>ri-add-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-add-circle-line' />
          <div className='label'>ri-add-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-add-fill' />
          <div className='label'>ri-add-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-add-line' />
          <div className='label'>ri-add-line</div>
        </div>
        <div className='icon'>
          <i className='ri-admin-fill' />
          <div className='label'>ri-admin-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-admin-line' />
          <div className='label'>ri-admin-line</div>
        </div>
        <div className='icon'>
          <i className='ri-advertisement-fill' />
          <div className='label'>ri-advertisement-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-advertisement-line' />
          <div className='label'>ri-advertisement-line</div>
        </div>
        <div className='icon'>
          <i className='ri-airplay-fill' />
          <div className='label'>ri-airplay-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-airplay-line' />
          <div className='label'>ri-airplay-line</div>
        </div>
        <div className='icon'>
          <i className='ri-alarm-fill' />
          <div className='label'>ri-alarm-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-alarm-line' />
          <div className='label'>ri-alarm-line</div>
        </div>
        <div className='icon'>
          <i className='ri-alarm-warning-fill' />
          <div className='label'>ri-alarm-warning-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-alarm-warning-line' />
          <div className='label'>ri-alarm-warning-line</div>
        </div>
        <div className='icon'>
          <i className='ri-album-fill' />
          <div className='label'>ri-album-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-album-line' />
          <div className='label'>ri-album-line</div>
        </div>
        <div className='icon'>
          <i className='ri-alert-fill' />
          <div className='label'>ri-alert-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-alert-line' />
          <div className='label'>ri-alert-line</div>
        </div>
        <div className='icon'>
          <i className='ri-aliens-fill' />
          <div className='label'>ri-aliens-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-aliens-line' />
          <div className='label'>ri-aliens-line</div>
        </div>
        <div className='icon'>
          <i className='ri-align-bottom' />
          <div className='label'>ri-align-bottom</div>
        </div>
        <div className='icon'>
          <i className='ri-align-center' />
          <div className='label'>ri-align-center</div>
        </div>
        <div className='icon'>
          <i className='ri-align-justify' />
          <div className='label'>ri-align-justify</div>
        </div>
        <div className='icon'>
          <i className='ri-align-left' />
          <div className='label'>ri-align-left</div>
        </div>
        <div className='icon'>
          <i className='ri-align-right' />
          <div className='label'>ri-align-right</div>
        </div>
        <div className='icon'>
          <i className='ri-align-top' />
          <div className='label'>ri-align-top</div>
        </div>
        <div className='icon'>
          <i className='ri-align-vertically' />
          <div className='label'>ri-align-vertically</div>
        </div>
        <div className='icon'>
          <i className='ri-alipay-fill' />
          <div className='label'>ri-alipay-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-alipay-line' />
          <div className='label'>ri-alipay-line</div>
        </div>
        <div className='icon'>
          <i className='ri-amazon-fill' />
          <div className='label'>ri-amazon-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-amazon-line' />
          <div className='label'>ri-amazon-line</div>
        </div>
        <div className='icon'>
          <i className='ri-anchor-fill' />
          <div className='label'>ri-anchor-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-anchor-line' />
          <div className='label'>ri-anchor-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ancient-gate-fill' />
          <div className='label'>ri-ancient-gate-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ancient-gate-line' />
          <div className='label'>ri-ancient-gate-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ancient-pavilion-fill' />
          <div className='label'>ri-ancient-pavilion-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ancient-pavilion-line' />
          <div className='label'>ri-ancient-pavilion-line</div>
        </div>
        <div className='icon'>
          <i className='ri-android-fill' />
          <div className='label'>ri-android-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-android-line' />
          <div className='label'>ri-android-line</div>
        </div>
        <div className='icon'>
          <i className='ri-angularjs-fill' />
          <div className='label'>ri-angularjs-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-angularjs-line' />
          <div className='label'>ri-angularjs-line</div>
        </div>
        <div className='icon'>
          <i className='ri-anticlockwise-2-fill' />
          <div className='label'>ri-anticlockwise-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-anticlockwise-2-line' />
          <div className='label'>ri-anticlockwise-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-anticlockwise-fill' />
          <div className='label'>ri-anticlockwise-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-anticlockwise-line' />
          <div className='label'>ri-anticlockwise-line</div>
        </div>
        <div className='icon'>
          <i className='ri-app-store-fill' />
          <div className='label'>ri-app-store-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-app-store-line' />
          <div className='label'>ri-app-store-line</div>
        </div>
        <div className='icon'>
          <i className='ri-apple-fill' />
          <div className='label'>ri-apple-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-apple-line' />
          <div className='label'>ri-apple-line</div>
        </div>
        <div className='icon'>
          <i className='ri-apps-2-fill' />
          <div className='label'>ri-apps-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-apps-2-line' />
          <div className='label'>ri-apps-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-apps-fill' />
          <div className='label'>ri-apps-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-apps-line' />
          <div className='label'>ri-apps-line</div>
        </div>
        <div className='icon'>
          <i className='ri-archive-drawer-fill' />
          <div className='label'>ri-archive-drawer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-archive-drawer-line' />
          <div className='label'>ri-archive-drawer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-archive-fill' />
          <div className='label'>ri-archive-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-archive-line' />
          <div className='label'>ri-archive-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-down-circle-fill' />
          <div className='label'>ri-arrow-down-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-down-circle-line' />
          <div className='label'>ri-arrow-down-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-down-fill' />
          <div className='label'>ri-arrow-down-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-down-line' />
          <div className='label'>ri-arrow-down-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-down-s-fill' />
          <div className='label'>ri-arrow-down-s-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-down-s-line' />
          <div className='label'>ri-arrow-down-s-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-drop-down-fill' />
          <div className='label'>ri-arrow-drop-down-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-drop-down-line' />
          <div className='label'>ri-arrow-drop-down-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-drop-left-fill' />
          <div className='label'>ri-arrow-drop-left-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-drop-left-line' />
          <div className='label'>ri-arrow-drop-left-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-drop-right-fill' />
          <div className='label'>ri-arrow-drop-right-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-drop-right-line' />
          <div className='label'>ri-arrow-drop-right-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-drop-up-fill' />
          <div className='label'>ri-arrow-drop-up-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-drop-up-line' />
          <div className='label'>ri-arrow-drop-up-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-go-back-fill' />
          <div className='label'>ri-arrow-go-back-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-go-back-line' />
          <div className='label'>ri-arrow-go-back-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-go-forward-fill' />
          <div className='label'>ri-arrow-go-forward-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-go-forward-line' />
          <div className='label'>ri-arrow-go-forward-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-circle-fill' />
          <div className='label'>ri-arrow-left-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-circle-line' />
          <div className='label'>ri-arrow-left-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-down-fill' />
          <div className='label'>ri-arrow-left-down-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-down-line' />
          <div className='label'>ri-arrow-left-down-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-fill' />
          <div className='label'>ri-arrow-left-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-line' />
          <div className='label'>ri-arrow-left-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-right-fill' />
          <div className='label'>ri-arrow-left-right-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-right-line' />
          <div className='label'>ri-arrow-left-right-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-s-fill' />
          <div className='label'>ri-arrow-left-s-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-s-line' />
          <div className='label'>ri-arrow-left-s-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-up-fill' />
          <div className='label'>ri-arrow-left-up-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-left-up-line' />
          <div className='label'>ri-arrow-left-up-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-right-circle-fill' />
          <div className='label'>ri-arrow-right-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-right-circle-line' />
          <div className='label'>ri-arrow-right-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-right-down-fill' />
          <div className='label'>ri-arrow-right-down-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-right-down-line' />
          <div className='label'>ri-arrow-right-down-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-right-fill' />
          <div className='label'>ri-arrow-right-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-right-line' />
          <div className='label'>ri-arrow-right-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-right-s-fill' />
          <div className='label'>ri-arrow-right-s-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-right-s-line' />
          <div className='label'>ri-arrow-right-s-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-right-up-fill' />
          <div className='label'>ri-arrow-right-up-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-right-up-line' />
          <div className='label'>ri-arrow-right-up-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-up-circle-fill' />
          <div className='label'>ri-arrow-up-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-up-circle-line' />
          <div className='label'>ri-arrow-up-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-up-down-fill' />
          <div className='label'>ri-arrow-up-down-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-up-down-line' />
          <div className='label'>ri-arrow-up-down-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-up-fill' />
          <div className='label'>ri-arrow-up-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-up-line' />
          <div className='label'>ri-arrow-up-line</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-up-s-fill' />
          <div className='label'>ri-arrow-up-s-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-arrow-up-s-line' />
          <div className='label'>ri-arrow-up-s-line</div>
        </div>
        <div className='icon'>
          <i className='ri-artboard-2-fill' />
          <div className='label'>ri-artboard-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-artboard-2-line' />
          <div className='label'>ri-artboard-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-artboard-fill' />
          <div className='label'>ri-artboard-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-artboard-line' />
          <div className='label'>ri-artboard-line</div>
        </div>
        <div className='icon'>
          <i className='ri-article-fill' />
          <div className='label'>ri-article-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-article-line' />
          <div className='label'>ri-article-line</div>
        </div>
        <div className='icon'>
          <i className='ri-aspect-ratio-fill' />
          <div className='label'>ri-aspect-ratio-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-aspect-ratio-line' />
          <div className='label'>ri-aspect-ratio-line</div>
        </div>
        <div className='icon'>
          <i className='ri-asterisk' />
          <div className='label'>ri-asterisk</div>
        </div>
        <div className='icon'>
          <i className='ri-at-fill' />
          <div className='label'>ri-at-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-at-line' />
          <div className='label'>ri-at-line</div>
        </div>
        <div className='icon'>
          <i className='ri-attachment-2' />
          <div className='label'>ri-attachment-2</div>
        </div>
        <div className='icon'>
          <i className='ri-attachment-fill' />
          <div className='label'>ri-attachment-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-attachment-line' />
          <div className='label'>ri-attachment-line</div>
        </div>
        <div className='icon'>
          <i className='ri-auction-fill' />
          <div className='label'>ri-auction-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-auction-line' />
          <div className='label'>ri-auction-line</div>
        </div>
        <div className='icon'>
          <i className='ri-award-fill' />
          <div className='label'>ri-award-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-award-line' />
          <div className='label'>ri-award-line</div>
        </div>
        <div className='icon'>
          <i className='ri-baidu-fill' />
          <div className='label'>ri-baidu-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-baidu-line' />
          <div className='label'>ri-baidu-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ball-pen-fill' />
          <div className='label'>ri-ball-pen-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ball-pen-line' />
          <div className='label'>ri-ball-pen-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bank-card-2-fill' />
          <div className='label'>ri-bank-card-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bank-card-2-line' />
          <div className='label'>ri-bank-card-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bank-card-fill' />
          <div className='label'>ri-bank-card-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bank-card-line' />
          <div className='label'>ri-bank-card-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bank-fill' />
          <div className='label'>ri-bank-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bank-line' />
          <div className='label'>ri-bank-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bar-chart-2-fill' />
          <div className='label'>ri-bar-chart-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bar-chart-2-line' />
          <div className='label'>ri-bar-chart-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bar-chart-box-fill' />
          <div className='label'>ri-bar-chart-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bar-chart-box-line' />
          <div className='label'>ri-bar-chart-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bar-chart-fill' />
          <div className='label'>ri-bar-chart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bar-chart-grouped-fill' />
          <div className='label'>ri-bar-chart-grouped-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bar-chart-grouped-line' />
          <div className='label'>ri-bar-chart-grouped-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bar-chart-horizontal-fill' />
          <div className='label'>ri-bar-chart-horizontal-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bar-chart-horizontal-line' />
          <div className='label'>ri-bar-chart-horizontal-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bar-chart-line' />
          <div className='label'>ri-bar-chart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-barcode-box-fill' />
          <div className='label'>ri-barcode-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-barcode-box-line' />
          <div className='label'>ri-barcode-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-barcode-fill' />
          <div className='label'>ri-barcode-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-barcode-line' />
          <div className='label'>ri-barcode-line</div>
        </div>
        <div className='icon'>
          <i className='ri-barricade-fill' />
          <div className='label'>ri-barricade-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-barricade-line' />
          <div className='label'>ri-barricade-line</div>
        </div>
        <div className='icon'>
          <i className='ri-base-station-fill' />
          <div className='label'>ri-base-station-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-base-station-line' />
          <div className='label'>ri-base-station-line</div>
        </div>
        <div className='icon'>
          <i className='ri-basketball-fill' />
          <div className='label'>ri-basketball-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-basketball-line' />
          <div className='label'>ri-basketball-line</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-2-charge-fill' />
          <div className='label'>ri-battery-2-charge-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-2-charge-line' />
          <div className='label'>ri-battery-2-charge-line</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-2-fill' />
          <div className='label'>ri-battery-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-2-line' />
          <div className='label'>ri-battery-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-charge-fill' />
          <div className='label'>ri-battery-charge-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-charge-line' />
          <div className='label'>ri-battery-charge-line</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-fill' />
          <div className='label'>ri-battery-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-line' />
          <div className='label'>ri-battery-line</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-low-fill' />
          <div className='label'>ri-battery-low-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-low-line' />
          <div className='label'>ri-battery-low-line</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-saver-fill' />
          <div className='label'>ri-battery-saver-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-saver-line' />
          <div className='label'>ri-battery-saver-line</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-share-fill' />
          <div className='label'>ri-battery-share-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-battery-share-line' />
          <div className='label'>ri-battery-share-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bear-smile-fill' />
          <div className='label'>ri-bear-smile-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bear-smile-line' />
          <div className='label'>ri-bear-smile-line</div>
        </div>
        <div className='icon'>
          <i className='ri-behance-fill' />
          <div className='label'>ri-behance-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-behance-line' />
          <div className='label'>ri-behance-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bell-fill' />
          <div className='label'>ri-bell-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bell-line' />
          <div className='label'>ri-bell-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bike-fill' />
          <div className='label'>ri-bike-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bike-line' />
          <div className='label'>ri-bike-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bilibili-fill' />
          <div className='label'>ri-bilibili-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bilibili-line' />
          <div className='label'>ri-bilibili-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bill-fill' />
          <div className='label'>ri-bill-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bill-line' />
          <div className='label'>ri-bill-line</div>
        </div>
        <div className='icon'>
          <i className='ri-billiards-fill' />
          <div className='label'>ri-billiards-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-billiards-line' />
          <div className='label'>ri-billiards-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bit-coin-fill' />
          <div className='label'>ri-bit-coin-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bit-coin-line' />
          <div className='label'>ri-bit-coin-line</div>
        </div>
        <div className='icon'>
          <i className='ri-blaze-fill' />
          <div className='label'>ri-blaze-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-blaze-line' />
          <div className='label'>ri-blaze-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bluetooth-connect-fill' />
          <div className='label'>ri-bluetooth-connect-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bluetooth-connect-line' />
          <div className='label'>ri-bluetooth-connect-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bluetooth-fill' />
          <div className='label'>ri-bluetooth-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bluetooth-line' />
          <div className='label'>ri-bluetooth-line</div>
        </div>
        <div className='icon'>
          <i className='ri-blur-off-fill' />
          <div className='label'>ri-blur-off-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-blur-off-line' />
          <div className='label'>ri-blur-off-line</div>
        </div>
        <div className='icon'>
          <i className='ri-body-scan-fill' />
          <div className='label'>ri-body-scan-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-body-scan-line' />
          <div className='label'>ri-body-scan-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bold' />
          <div className='label'>ri-bold</div>
        </div>
        <div className='icon'>
          <i className='ri-book-2-fill' />
          <div className='label'>ri-book-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-book-2-line' />
          <div className='label'>ri-book-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-book-3-fill' />
          <div className='label'>ri-book-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-book-3-line' />
          <div className='label'>ri-book-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-book-fill' />
          <div className='label'>ri-book-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-book-line' />
          <div className='label'>ri-book-line</div>
        </div>
        <div className='icon'>
          <i className='ri-book-mark-fill' />
          <div className='label'>ri-book-mark-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-book-mark-line' />
          <div className='label'>ri-book-mark-line</div>
        </div>
        <div className='icon'>
          <i className='ri-book-open-fill' />
          <div className='label'>ri-book-open-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-book-open-line' />
          <div className='label'>ri-book-open-line</div>
        </div>
        <div className='icon'>
          <i className='ri-book-read-fill' />
          <div className='label'>ri-book-read-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-book-read-line' />
          <div className='label'>ri-book-read-line</div>
        </div>
        <div className='icon'>
          <i className='ri-booklet-fill' />
          <div className='label'>ri-booklet-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-booklet-line' />
          <div className='label'>ri-booklet-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bookmark-2-fill' />
          <div className='label'>ri-bookmark-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bookmark-2-line' />
          <div className='label'>ri-bookmark-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bookmark-3-fill' />
          <div className='label'>ri-bookmark-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bookmark-3-line' />
          <div className='label'>ri-bookmark-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bookmark-fill' />
          <div className='label'>ri-bookmark-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bookmark-line' />
          <div className='label'>ri-bookmark-line</div>
        </div>
        <div className='icon'>
          <i className='ri-boxing-fill' />
          <div className='label'>ri-boxing-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-boxing-line' />
          <div className='label'>ri-boxing-line</div>
        </div>
        <div className='icon'>
          <i className='ri-braces-fill' />
          <div className='label'>ri-braces-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-braces-line' />
          <div className='label'>ri-braces-line</div>
        </div>
        <div className='icon'>
          <i className='ri-brackets-fill' />
          <div className='label'>ri-brackets-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-brackets-line' />
          <div className='label'>ri-brackets-line</div>
        </div>
        <div className='icon'>
          <i className='ri-briefcase-2-fill' />
          <div className='label'>ri-briefcase-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-briefcase-2-line' />
          <div className='label'>ri-briefcase-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-briefcase-3-fill' />
          <div className='label'>ri-briefcase-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-briefcase-3-line' />
          <div className='label'>ri-briefcase-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-briefcase-4-fill' />
          <div className='label'>ri-briefcase-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-briefcase-4-line' />
          <div className='label'>ri-briefcase-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-briefcase-5-fill' />
          <div className='label'>ri-briefcase-5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-briefcase-5-line' />
          <div className='label'>ri-briefcase-5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-briefcase-fill' />
          <div className='label'>ri-briefcase-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-briefcase-line' />
          <div className='label'>ri-briefcase-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bring-forward' />
          <div className='label'>ri-bring-forward</div>
        </div>
        <div className='icon'>
          <i className='ri-bring-to-front' />
          <div className='label'>ri-bring-to-front</div>
        </div>
        <div className='icon'>
          <i className='ri-broadcast-fill' />
          <div className='label'>ri-broadcast-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-broadcast-line' />
          <div className='label'>ri-broadcast-line</div>
        </div>
        <div className='icon'>
          <i className='ri-brush-2-fill' />
          <div className='label'>ri-brush-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-brush-2-line' />
          <div className='label'>ri-brush-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-brush-3-fill' />
          <div className='label'>ri-brush-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-brush-3-line' />
          <div className='label'>ri-brush-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-brush-4-fill' />
          <div className='label'>ri-brush-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-brush-4-line' />
          <div className='label'>ri-brush-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-brush-fill' />
          <div className='label'>ri-brush-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-brush-line' />
          <div className='label'>ri-brush-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bubble-chart-fill' />
          <div className='label'>ri-bubble-chart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bubble-chart-line' />
          <div className='label'>ri-bubble-chart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bug-2-fill' />
          <div className='label'>ri-bug-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bug-2-line' />
          <div className='label'>ri-bug-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bug-fill' />
          <div className='label'>ri-bug-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bug-line' />
          <div className='label'>ri-bug-line</div>
        </div>
        <div className='icon'>
          <i className='ri-building-2-fill' />
          <div className='label'>ri-building-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-building-2-line' />
          <div className='label'>ri-building-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-building-3-fill' />
          <div className='label'>ri-building-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-building-3-line' />
          <div className='label'>ri-building-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-building-4-fill' />
          <div className='label'>ri-building-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-building-4-line' />
          <div className='label'>ri-building-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-building-fill' />
          <div className='label'>ri-building-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-building-line' />
          <div className='label'>ri-building-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bus-2-fill' />
          <div className='label'>ri-bus-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bus-2-line' />
          <div className='label'>ri-bus-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bus-fill' />
          <div className='label'>ri-bus-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bus-line' />
          <div className='label'>ri-bus-line</div>
        </div>
        <div className='icon'>
          <i className='ri-bus-wifi-fill' />
          <div className='label'>ri-bus-wifi-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-bus-wifi-line' />
          <div className='label'>ri-bus-wifi-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cactus-fill' />
          <div className='label'>ri-cactus-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cactus-line' />
          <div className='label'>ri-cactus-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cake-2-fill' />
          <div className='label'>ri-cake-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cake-2-line' />
          <div className='label'>ri-cake-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cake-3-fill' />
          <div className='label'>ri-cake-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cake-3-line' />
          <div className='label'>ri-cake-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cake-fill' />
          <div className='label'>ri-cake-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cake-line' />
          <div className='label'>ri-cake-line</div>
        </div>
        <div className='icon'>
          <i className='ri-calculator-fill' />
          <div className='label'>ri-calculator-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-calculator-line' />
          <div className='label'>ri-calculator-line</div>
        </div>
        <div className='icon'>
          <i className='ri-calendar-2-fill' />
          <div className='label'>ri-calendar-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-calendar-2-line' />
          <div className='label'>ri-calendar-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-calendar-check-fill' />
          <div className='label'>ri-calendar-check-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-calendar-check-line' />
          <div className='label'>ri-calendar-check-line</div>
        </div>
        <div className='icon'>
          <i className='ri-calendar-event-fill' />
          <div className='label'>ri-calendar-event-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-calendar-event-line' />
          <div className='label'>ri-calendar-event-line</div>
        </div>
        <div className='icon'>
          <i className='ri-calendar-fill' />
          <div className='label'>ri-calendar-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-calendar-line' />
          <div className='label'>ri-calendar-line</div>
        </div>
        <div className='icon'>
          <i className='ri-calendar-todo-fill' />
          <div className='label'>ri-calendar-todo-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-calendar-todo-line' />
          <div className='label'>ri-calendar-todo-line</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-2-fill' />
          <div className='label'>ri-camera-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-2-line' />
          <div className='label'>ri-camera-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-3-fill' />
          <div className='label'>ri-camera-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-3-line' />
          <div className='label'>ri-camera-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-fill' />
          <div className='label'>ri-camera-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-lens-fill' />
          <div className='label'>ri-camera-lens-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-lens-line' />
          <div className='label'>ri-camera-lens-line</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-line' />
          <div className='label'>ri-camera-line</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-off-fill' />
          <div className='label'>ri-camera-off-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-off-line' />
          <div className='label'>ri-camera-off-line</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-switch-fill' />
          <div className='label'>ri-camera-switch-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-camera-switch-line' />
          <div className='label'>ri-camera-switch-line</div>
        </div>
        <div className='icon'>
          <i className='ri-capsule-fill' />
          <div className='label'>ri-capsule-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-capsule-line' />
          <div className='label'>ri-capsule-line</div>
        </div>
        <div className='icon'>
          <i className='ri-car-fill' />
          <div className='label'>ri-car-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-car-line' />
          <div className='label'>ri-car-line</div>
        </div>
        <div className='icon'>
          <i className='ri-car-washing-fill' />
          <div className='label'>ri-car-washing-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-car-washing-line' />
          <div className='label'>ri-car-washing-line</div>
        </div>
        <div className='icon'>
          <i className='ri-caravan-fill' />
          <div className='label'>ri-caravan-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-caravan-line' />
          <div className='label'>ri-caravan-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cast-fill' />
          <div className='label'>ri-cast-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cast-line' />
          <div className='label'>ri-cast-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cellphone-fill' />
          <div className='label'>ri-cellphone-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cellphone-line' />
          <div className='label'>ri-cellphone-line</div>
        </div>
        <div className='icon'>
          <i className='ri-celsius-fill' />
          <div className='label'>ri-celsius-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-celsius-line' />
          <div className='label'>ri-celsius-line</div>
        </div>
        <div className='icon'>
          <i className='ri-centos-fill' />
          <div className='label'>ri-centos-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-centos-line' />
          <div className='label'>ri-centos-line</div>
        </div>
        <div className='icon'>
          <i className='ri-character-recognition-fill' />
          <div className='label'>ri-character-recognition-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-character-recognition-line' />
          <div className='label'>ri-character-recognition-line</div>
        </div>
        <div className='icon'>
          <i className='ri-charging-pile-2-fill' />
          <div className='label'>ri-charging-pile-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-charging-pile-2-line' />
          <div className='label'>ri-charging-pile-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-charging-pile-fill' />
          <div className='label'>ri-charging-pile-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-charging-pile-line' />
          <div className='label'>ri-charging-pile-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-1-fill' />
          <div className='label'>ri-chat-1-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-1-line' />
          <div className='label'>ri-chat-1-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-2-fill' />
          <div className='label'>ri-chat-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-2-line' />
          <div className='label'>ri-chat-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-3-fill' />
          <div className='label'>ri-chat-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-3-line' />
          <div className='label'>ri-chat-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-4-fill' />
          <div className='label'>ri-chat-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-4-line' />
          <div className='label'>ri-chat-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-check-fill' />
          <div className='label'>ri-chat-check-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-check-line' />
          <div className='label'>ri-chat-check-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-delete-fill' />
          <div className='label'>ri-chat-delete-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-delete-line' />
          <div className='label'>ri-chat-delete-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-download-fill' />
          <div className='label'>ri-chat-download-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-download-line' />
          <div className='label'>ri-chat-download-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-follow-up-fill' />
          <div className='label'>ri-chat-follow-up-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-follow-up-line' />
          <div className='label'>ri-chat-follow-up-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-forward-fill' />
          <div className='label'>ri-chat-forward-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-forward-line' />
          <div className='label'>ri-chat-forward-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-heart-fill' />
          <div className='label'>ri-chat-heart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-heart-line' />
          <div className='label'>ri-chat-heart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-history-fill' />
          <div className='label'>ri-chat-history-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-history-line' />
          <div className='label'>ri-chat-history-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-new-fill' />
          <div className='label'>ri-chat-new-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-new-line' />
          <div className='label'>ri-chat-new-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-off-fill' />
          <div className='label'>ri-chat-off-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-off-line' />
          <div className='label'>ri-chat-off-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-poll-fill' />
          <div className='label'>ri-chat-poll-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-poll-line' />
          <div className='label'>ri-chat-poll-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-private-fill' />
          <div className='label'>ri-chat-private-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-private-line' />
          <div className='label'>ri-chat-private-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-quote-fill' />
          <div className='label'>ri-chat-quote-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-quote-line' />
          <div className='label'>ri-chat-quote-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-settings-fill' />
          <div className='label'>ri-chat-settings-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-settings-line' />
          <div className='label'>ri-chat-settings-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-smile-2-fill' />
          <div className='label'>ri-chat-smile-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-smile-2-line' />
          <div className='label'>ri-chat-smile-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-smile-3-fill' />
          <div className='label'>ri-chat-smile-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-smile-3-line' />
          <div className='label'>ri-chat-smile-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-smile-fill' />
          <div className='label'>ri-chat-smile-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-smile-line' />
          <div className='label'>ri-chat-smile-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-upload-fill' />
          <div className='label'>ri-chat-upload-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-upload-line' />
          <div className='label'>ri-chat-upload-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-voice-fill' />
          <div className='label'>ri-chat-voice-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chat-voice-line' />
          <div className='label'>ri-chat-voice-line</div>
        </div>
        <div className='icon'>
          <i className='ri-check-double-fill' />
          <div className='label'>ri-check-double-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-check-double-line' />
          <div className='label'>ri-check-double-line</div>
        </div>
        <div className='icon'>
          <i className='ri-check-fill' />
          <div className='label'>ri-check-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-check-line' />
          <div className='label'>ri-check-line</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-blank-circle-fill' />
          <div className='label'>ri-checkbox-blank-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-blank-circle-line' />
          <div className='label'>ri-checkbox-blank-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-blank-fill' />
          <div className='label'>ri-checkbox-blank-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-blank-line' />
          <div className='label'>ri-checkbox-blank-line</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-circle-fill' />
          <div className='label'>ri-checkbox-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-circle-line' />
          <div className='label'>ri-checkbox-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-fill' />
          <div className='label'>ri-checkbox-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-indeterminate-fill' />
          <div className='label'>ri-checkbox-indeterminate-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-indeterminate-line' />
          <div className='label'>ri-checkbox-indeterminate-line</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-line' />
          <div className='label'>ri-checkbox-line</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-multiple-blank-fill' />
          <div className='label'>ri-checkbox-multiple-blank-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-multiple-blank-line' />
          <div className='label'>ri-checkbox-multiple-blank-line</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-multiple-fill' />
          <div className='label'>ri-checkbox-multiple-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-checkbox-multiple-line' />
          <div className='label'>ri-checkbox-multiple-line</div>
        </div>
        <div className='icon'>
          <i className='ri-china-railway-fill' />
          <div className='label'>ri-china-railway-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-china-railway-line' />
          <div className='label'>ri-china-railway-line</div>
        </div>
        <div className='icon'>
          <i className='ri-chrome-fill' />
          <div className='label'>ri-chrome-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-chrome-line' />
          <div className='label'>ri-chrome-line</div>
        </div>
        <div className='icon'>
          <i className='ri-clapperboard-fill' />
          <div className='label'>ri-clapperboard-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-clapperboard-line' />
          <div className='label'>ri-clapperboard-line</div>
        </div>
        <div className='icon'>
          <i className='ri-clipboard-fill' />
          <div className='label'>ri-clipboard-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-clipboard-line' />
          <div className='label'>ri-clipboard-line</div>
        </div>
        <div className='icon'>
          <i className='ri-clockwise-2-fill' />
          <div className='label'>ri-clockwise-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-clockwise-2-line' />
          <div className='label'>ri-clockwise-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-clockwise-fill' />
          <div className='label'>ri-clockwise-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-clockwise-line' />
          <div className='label'>ri-clockwise-line</div>
        </div>
        <div className='icon'>
          <i className='ri-close-circle-fill' />
          <div className='label'>ri-close-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-close-circle-line' />
          <div className='label'>ri-close-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-close-fill' />
          <div className='label'>ri-close-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-close-line' />
          <div className='label'>ri-close-line</div>
        </div>
        <div className='icon'>
          <i className='ri-closed-captioning-fill' />
          <div className='label'>ri-closed-captioning-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-closed-captioning-line' />
          <div className='label'>ri-closed-captioning-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cloud-fill' />
          <div className='label'>ri-cloud-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cloud-line' />
          <div className='label'>ri-cloud-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cloud-off-fill' />
          <div className='label'>ri-cloud-off-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cloud-off-line' />
          <div className='label'>ri-cloud-off-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cloud-windy-fill' />
          <div className='label'>ri-cloud-windy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cloud-windy-line' />
          <div className='label'>ri-cloud-windy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cloudy-2-fill' />
          <div className='label'>ri-cloudy-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cloudy-2-line' />
          <div className='label'>ri-cloudy-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cloudy-fill' />
          <div className='label'>ri-cloudy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cloudy-line' />
          <div className='label'>ri-cloudy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-code-box-fill' />
          <div className='label'>ri-code-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-code-box-line' />
          <div className='label'>ri-code-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-code-fill' />
          <div className='label'>ri-code-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-code-line' />
          <div className='label'>ri-code-line</div>
        </div>
        <div className='icon'>
          <i className='ri-code-s-fill' />
          <div className='label'>ri-code-s-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-code-s-line' />
          <div className='label'>ri-code-s-line</div>
        </div>
        <div className='icon'>
          <i className='ri-code-s-slash-fill' />
          <div className='label'>ri-code-s-slash-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-code-s-slash-line' />
          <div className='label'>ri-code-s-slash-line</div>
        </div>
        <div className='icon'>
          <i className='ri-code-view' />
          <div className='label'>ri-code-view</div>
        </div>
        <div className='icon'>
          <i className='ri-codepen-fill' />
          <div className='label'>ri-codepen-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-codepen-line' />
          <div className='label'>ri-codepen-line</div>
        </div>
        <div className='icon'>
          <i className='ri-coin-fill' />
          <div className='label'>ri-coin-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-coin-line' />
          <div className='label'>ri-coin-line</div>
        </div>
        <div className='icon'>
          <i className='ri-coins-fill' />
          <div className='label'>ri-coins-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-coins-line' />
          <div className='label'>ri-coins-line</div>
        </div>
        <div className='icon'>
          <i className='ri-collage-fill' />
          <div className='label'>ri-collage-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-collage-line' />
          <div className='label'>ri-collage-line</div>
        </div>
        <div className='icon'>
          <i className='ri-command-fill' />
          <div className='label'>ri-command-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-command-line' />
          <div className='label'>ri-command-line</div>
        </div>
        <div className='icon'>
          <i className='ri-community-fill' />
          <div className='label'>ri-community-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-community-line' />
          <div className='label'>ri-community-line</div>
        </div>
        <div className='icon'>
          <i className='ri-compass-2-fill' />
          <div className='label'>ri-compass-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-compass-2-line' />
          <div className='label'>ri-compass-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-compass-3-fill' />
          <div className='label'>ri-compass-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-compass-3-line' />
          <div className='label'>ri-compass-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-compass-4-fill' />
          <div className='label'>ri-compass-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-compass-4-line' />
          <div className='label'>ri-compass-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-compass-discover-fill' />
          <div className='label'>ri-compass-discover-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-compass-discover-line' />
          <div className='label'>ri-compass-discover-line</div>
        </div>
        <div className='icon'>
          <i className='ri-compass-fill' />
          <div className='label'>ri-compass-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-compass-line' />
          <div className='label'>ri-compass-line</div>
        </div>
        <div className='icon'>
          <i className='ri-compasses-2-fill' />
          <div className='label'>ri-compasses-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-compasses-2-line' />
          <div className='label'>ri-compasses-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-compasses-fill' />
          <div className='label'>ri-compasses-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-compasses-line' />
          <div className='label'>ri-compasses-line</div>
        </div>
        <div className='icon'>
          <i className='ri-computer-fill' />
          <div className='label'>ri-computer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-computer-line' />
          <div className='label'>ri-computer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-contacts-book-2-fill' />
          <div className='label'>ri-contacts-book-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-contacts-book-2-line' />
          <div className='label'>ri-contacts-book-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-contacts-book-fill' />
          <div className='label'>ri-contacts-book-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-contacts-book-line' />
          <div className='label'>ri-contacts-book-line</div>
        </div>
        <div className='icon'>
          <i className='ri-contacts-book-upload-fill' />
          <div className='label'>ri-contacts-book-upload-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-contacts-book-upload-line' />
          <div className='label'>ri-contacts-book-upload-line</div>
        </div>
        <div className='icon'>
          <i className='ri-contacts-fill' />
          <div className='label'>ri-contacts-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-contacts-line' />
          <div className='label'>ri-contacts-line</div>
        </div>
        <div className='icon'>
          <i className='ri-contrast-2-fill' />
          <div className='label'>ri-contrast-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-contrast-2-line' />
          <div className='label'>ri-contrast-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-contrast-drop-2-fill' />
          <div className='label'>ri-contrast-drop-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-contrast-drop-2-line' />
          <div className='label'>ri-contrast-drop-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-contrast-drop-fill' />
          <div className='label'>ri-contrast-drop-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-contrast-drop-line' />
          <div className='label'>ri-contrast-drop-line</div>
        </div>
        <div className='icon'>
          <i className='ri-contrast-fill' />
          <div className='label'>ri-contrast-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-contrast-line' />
          <div className='label'>ri-contrast-line</div>
        </div>
        <div className='icon'>
          <i className='ri-copper-coin-fill' />
          <div className='label'>ri-copper-coin-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-copper-coin-line' />
          <div className='label'>ri-copper-coin-line</div>
        </div>
        <div className='icon'>
          <i className='ri-copper-diamond-fill' />
          <div className='label'>ri-copper-diamond-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-copper-diamond-line' />
          <div className='label'>ri-copper-diamond-line</div>
        </div>
        <div className='icon'>
          <i className='ri-copyleft-fill' />
          <div className='label'>ri-copyleft-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-copyleft-line' />
          <div className='label'>ri-copyleft-line</div>
        </div>
        <div className='icon'>
          <i className='ri-copyright-fill' />
          <div className='label'>ri-copyright-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-copyright-line' />
          <div className='label'>ri-copyright-line</div>
        </div>
        <div className='icon'>
          <i className='ri-coreos-fill' />
          <div className='label'>ri-coreos-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-coreos-line' />
          <div className='label'>ri-coreos-line</div>
        </div>
        <div className='icon'>
          <i className='ri-coupon-2-fill' />
          <div className='label'>ri-coupon-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-coupon-2-line' />
          <div className='label'>ri-coupon-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-coupon-3-fill' />
          <div className='label'>ri-coupon-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-coupon-3-line' />
          <div className='label'>ri-coupon-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-coupon-4-fill' />
          <div className='label'>ri-coupon-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-coupon-4-line' />
          <div className='label'>ri-coupon-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-coupon-5-fill' />
          <div className='label'>ri-coupon-5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-coupon-5-line' />
          <div className='label'>ri-coupon-5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-coupon-fill' />
          <div className='label'>ri-coupon-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-coupon-line' />
          <div className='label'>ri-coupon-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cpu-fill' />
          <div className='label'>ri-cpu-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cpu-line' />
          <div className='label'>ri-cpu-line</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-by-fill' />
          <div className='label'>ri-creative-commons-by-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-by-line' />
          <div className='label'>ri-creative-commons-by-line</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-fill' />
          <div className='label'>ri-creative-commons-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-line' />
          <div className='label'>ri-creative-commons-line</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-nc-fill' />
          <div className='label'>ri-creative-commons-nc-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-nc-line' />
          <div className='label'>ri-creative-commons-nc-line</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-nd-fill' />
          <div className='label'>ri-creative-commons-nd-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-nd-line' />
          <div className='label'>ri-creative-commons-nd-line</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-sa-fill' />
          <div className='label'>ri-creative-commons-sa-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-sa-line' />
          <div className='label'>ri-creative-commons-sa-line</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-zero-fill' />
          <div className='label'>ri-creative-commons-zero-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-creative-commons-zero-line' />
          <div className='label'>ri-creative-commons-zero-line</div>
        </div>
        <div className='icon'>
          <i className='ri-criminal-fill' />
          <div className='label'>ri-criminal-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-criminal-line' />
          <div className='label'>ri-criminal-line</div>
        </div>
        <div className='icon'>
          <i className='ri-crop-2-fill' />
          <div className='label'>ri-crop-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-crop-2-line' />
          <div className='label'>ri-crop-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-crop-fill' />
          <div className='label'>ri-crop-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-crop-line' />
          <div className='label'>ri-crop-line</div>
        </div>
        <div className='icon'>
          <i className='ri-css3-fill' />
          <div className='label'>ri-css3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-css3-line' />
          <div className='label'>ri-css3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cup-fill' />
          <div className='label'>ri-cup-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cup-line' />
          <div className='label'>ri-cup-line</div>
        </div>
        <div className='icon'>
          <i className='ri-currency-fill' />
          <div className='label'>ri-currency-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-currency-line' />
          <div className='label'>ri-currency-line</div>
        </div>
        <div className='icon'>
          <i className='ri-cursor-fill' />
          <div className='label'>ri-cursor-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-cursor-line' />
          <div className='label'>ri-cursor-line</div>
        </div>
        <div className='icon'>
          <i className='ri-customer-service-2-fill' />
          <div className='label'>ri-customer-service-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-customer-service-2-line' />
          <div className='label'>ri-customer-service-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-customer-service-fill' />
          <div className='label'>ri-customer-service-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-customer-service-line' />
          <div className='label'>ri-customer-service-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dashboard-2-fill' />
          <div className='label'>ri-dashboard-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dashboard-2-line' />
          <div className='label'>ri-dashboard-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dashboard-3-fill' />
          <div className='label'>ri-dashboard-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dashboard-3-line' />
          <div className='label'>ri-dashboard-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dashboard-fill' />
          <div className='label'>ri-dashboard-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dashboard-line' />
          <div className='label'>ri-dashboard-line</div>
        </div>
        <div className='icon'>
          <i className='ri-database-2-fill' />
          <div className='label'>ri-database-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-database-2-line' />
          <div className='label'>ri-database-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-database-fill' />
          <div className='label'>ri-database-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-database-line' />
          <div className='label'>ri-database-line</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-back-2-fill' />
          <div className='label'>ri-delete-back-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-back-2-line' />
          <div className='label'>ri-delete-back-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-back-fill' />
          <div className='label'>ri-delete-back-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-back-line' />
          <div className='label'>ri-delete-back-line</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-2-fill' />
          <div className='label'>ri-delete-bin-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-2-line' />
          <div className='label'>ri-delete-bin-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-3-fill' />
          <div className='label'>ri-delete-bin-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-3-line' />
          <div className='label'>ri-delete-bin-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-4-fill' />
          <div className='label'>ri-delete-bin-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-4-line' />
          <div className='label'>ri-delete-bin-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-5-fill' />
          <div className='label'>ri-delete-bin-5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-5-line' />
          <div className='label'>ri-delete-bin-5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-6-fill' />
          <div className='label'>ri-delete-bin-6-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-6-line' />
          <div className='label'>ri-delete-bin-6-line</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-7-fill' />
          <div className='label'>ri-delete-bin-7-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-7-line' />
          <div className='label'>ri-delete-bin-7-line</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-fill' />
          <div className='label'>ri-delete-bin-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-bin-line' />
          <div className='label'>ri-delete-bin-line</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-column' />
          <div className='label'>ri-delete-column</div>
        </div>
        <div className='icon'>
          <i className='ri-delete-row' />
          <div className='label'>ri-delete-row</div>
        </div>
        <div className='icon'>
          <i className='ri-device-fill' />
          <div className='label'>ri-device-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-device-line' />
          <div className='label'>ri-device-line</div>
        </div>
        <div className='icon'>
          <i className='ri-device-recover-fill' />
          <div className='label'>ri-device-recover-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-device-recover-line' />
          <div className='label'>ri-device-recover-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dingding-fill' />
          <div className='label'>ri-dingding-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dingding-line' />
          <div className='label'>ri-dingding-line</div>
        </div>
        <div className='icon'>
          <i className='ri-direction-fill' />
          <div className='label'>ri-direction-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-direction-line' />
          <div className='label'>ri-direction-line</div>
        </div>
        <div className='icon'>
          <i className='ri-disc-fill' />
          <div className='label'>ri-disc-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-disc-line' />
          <div className='label'>ri-disc-line</div>
        </div>
        <div className='icon'>
          <i className='ri-discord-fill' />
          <div className='label'>ri-discord-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-discord-line' />
          <div className='label'>ri-discord-line</div>
        </div>
        <div className='icon'>
          <i className='ri-discuss-fill' />
          <div className='label'>ri-discuss-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-discuss-line' />
          <div className='label'>ri-discuss-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dislike-fill' />
          <div className='label'>ri-dislike-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dislike-line' />
          <div className='label'>ri-dislike-line</div>
        </div>
        <div className='icon'>
          <i className='ri-disqus-fill' />
          <div className='label'>ri-disqus-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-disqus-line' />
          <div className='label'>ri-disqus-line</div>
        </div>
        <div className='icon'>
          <i className='ri-divide-fill' />
          <div className='label'>ri-divide-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-divide-line' />
          <div className='label'>ri-divide-line</div>
        </div>
        <div className='icon'>
          <i className='ri-donut-chart-fill' />
          <div className='label'>ri-donut-chart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-donut-chart-line' />
          <div className='label'>ri-donut-chart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-door-closed-fill' />
          <div className='label'>ri-door-closed-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-door-closed-line' />
          <div className='label'>ri-door-closed-line</div>
        </div>
        <div className='icon'>
          <i className='ri-door-fill' />
          <div className='label'>ri-door-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-door-line' />
          <div className='label'>ri-door-line</div>
        </div>
        <div className='icon'>
          <i className='ri-door-lock-box-fill' />
          <div className='label'>ri-door-lock-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-door-lock-box-line' />
          <div className='label'>ri-door-lock-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-door-lock-fill' />
          <div className='label'>ri-door-lock-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-door-lock-line' />
          <div className='label'>ri-door-lock-line</div>
        </div>
        <div className='icon'>
          <i className='ri-door-open-fill' />
          <div className='label'>ri-door-open-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-door-open-line' />
          <div className='label'>ri-door-open-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dossier-fill' />
          <div className='label'>ri-dossier-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dossier-line' />
          <div className='label'>ri-dossier-line</div>
        </div>
        <div className='icon'>
          <i className='ri-douban-fill' />
          <div className='label'>ri-douban-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-douban-line' />
          <div className='label'>ri-douban-line</div>
        </div>
        <div className='icon'>
          <i className='ri-double-quotes-l' />
          <div className='label'>ri-double-quotes-l</div>
        </div>
        <div className='icon'>
          <i className='ri-double-quotes-r' />
          <div className='label'>ri-double-quotes-r</div>
        </div>
        <div className='icon'>
          <i className='ri-download-2-fill' />
          <div className='label'>ri-download-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-download-2-line' />
          <div className='label'>ri-download-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-download-cloud-2-fill' />
          <div className='label'>ri-download-cloud-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-download-cloud-2-line' />
          <div className='label'>ri-download-cloud-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-download-cloud-fill' />
          <div className='label'>ri-download-cloud-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-download-cloud-line' />
          <div className='label'>ri-download-cloud-line</div>
        </div>
        <div className='icon'>
          <i className='ri-download-fill' />
          <div className='label'>ri-download-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-download-line' />
          <div className='label'>ri-download-line</div>
        </div>
        <div className='icon'>
          <i className='ri-draft-fill' />
          <div className='label'>ri-draft-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-draft-line' />
          <div className='label'>ri-draft-line</div>
        </div>
        <div className='icon'>
          <i className='ri-drag-drop-fill' />
          <div className='label'>ri-drag-drop-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-drag-drop-line' />
          <div className='label'>ri-drag-drop-line</div>
        </div>
        <div className='icon'>
          <i className='ri-drag-move-2-fill' />
          <div className='label'>ri-drag-move-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-drag-move-2-line' />
          <div className='label'>ri-drag-move-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-drag-move-fill' />
          <div className='label'>ri-drag-move-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-drag-move-line' />
          <div className='label'>ri-drag-move-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dribbble-fill' />
          <div className='label'>ri-dribbble-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dribbble-line' />
          <div className='label'>ri-dribbble-line</div>
        </div>
        <div className='icon'>
          <i className='ri-drive-fill' />
          <div className='label'>ri-drive-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-drive-line' />
          <div className='label'>ri-drive-line</div>
        </div>
        <div className='icon'>
          <i className='ri-drizzle-fill' />
          <div className='label'>ri-drizzle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-drizzle-line' />
          <div className='label'>ri-drizzle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-drop-fill' />
          <div className='label'>ri-drop-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-drop-line' />
          <div className='label'>ri-drop-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dropbox-fill' />
          <div className='label'>ri-dropbox-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dropbox-line' />
          <div className='label'>ri-dropbox-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dual-sim-1-fill' />
          <div className='label'>ri-dual-sim-1-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dual-sim-1-line' />
          <div className='label'>ri-dual-sim-1-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dual-sim-2-fill' />
          <div className='label'>ri-dual-sim-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dual-sim-2-line' />
          <div className='label'>ri-dual-sim-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dv-fill' />
          <div className='label'>ri-dv-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dv-line' />
          <div className='label'>ri-dv-line</div>
        </div>
        <div className='icon'>
          <i className='ri-dvd-fill' />
          <div className='label'>ri-dvd-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-dvd-line' />
          <div className='label'>ri-dvd-line</div>
        </div>
        <div className='icon'>
          <i className='ri-e-bike-2-fill' />
          <div className='label'>ri-e-bike-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-e-bike-2-line' />
          <div className='label'>ri-e-bike-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-e-bike-fill' />
          <div className='label'>ri-e-bike-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-e-bike-line' />
          <div className='label'>ri-e-bike-line</div>
        </div>
        <div className='icon'>
          <i className='ri-earth-fill' />
          <div className='label'>ri-earth-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-earth-line' />
          <div className='label'>ri-earth-line</div>
        </div>
        <div className='icon'>
          <i className='ri-earthquake-fill' />
          <div className='label'>ri-earthquake-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-earthquake-line' />
          <div className='label'>ri-earthquake-line</div>
        </div>
        <div className='icon'>
          <i className='ri-edge-fill' />
          <div className='label'>ri-edge-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-edge-line' />
          <div className='label'>ri-edge-line</div>
        </div>
        <div className='icon'>
          <i className='ri-edit-2-fill' />
          <div className='label'>ri-edit-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-edit-2-line' />
          <div className='label'>ri-edit-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-edit-box-fill' />
          <div className='label'>ri-edit-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-edit-box-line' />
          <div className='label'>ri-edit-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-edit-circle-fill' />
          <div className='label'>ri-edit-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-edit-circle-line' />
          <div className='label'>ri-edit-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-edit-fill' />
          <div className='label'>ri-edit-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-edit-line' />
          <div className='label'>ri-edit-line</div>
        </div>
        <div className='icon'>
          <i className='ri-eject-fill' />
          <div className='label'>ri-eject-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-eject-line' />
          <div className='label'>ri-eject-line</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-2-fill' />
          <div className='label'>ri-emotion-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-2-line' />
          <div className='label'>ri-emotion-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-fill' />
          <div className='label'>ri-emotion-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-happy-fill' />
          <div className='label'>ri-emotion-happy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-happy-line' />
          <div className='label'>ri-emotion-happy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-laugh-fill' />
          <div className='label'>ri-emotion-laugh-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-laugh-line' />
          <div className='label'>ri-emotion-laugh-line</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-line' />
          <div className='label'>ri-emotion-line</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-normal-fill' />
          <div className='label'>ri-emotion-normal-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-normal-line' />
          <div className='label'>ri-emotion-normal-line</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-sad-fill' />
          <div className='label'>ri-emotion-sad-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-sad-line' />
          <div className='label'>ri-emotion-sad-line</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-unhappy-fill' />
          <div className='label'>ri-emotion-unhappy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-emotion-unhappy-line' />
          <div className='label'>ri-emotion-unhappy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-empathize-fill' />
          <div className='label'>ri-empathize-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-empathize-line' />
          <div className='label'>ri-empathize-line</div>
        </div>
        <div className='icon'>
          <i className='ri-emphasis-cn' />
          <div className='label'>ri-emphasis-cn</div>
        </div>
        <div className='icon'>
          <i className='ri-emphasis' />
          <div className='label'>ri-emphasis</div>
        </div>
        <div className='icon'>
          <i className='ri-english-input' />
          <div className='label'>ri-english-input</div>
        </div>
        <div className='icon'>
          <i className='ri-equalizer-fill' />
          <div className='label'>ri-equalizer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-equalizer-line' />
          <div className='label'>ri-equalizer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-eraser-fill' />
          <div className='label'>ri-eraser-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-eraser-line' />
          <div className='label'>ri-eraser-line</div>
        </div>
        <div className='icon'>
          <i className='ri-error-warning-fill' />
          <div className='label'>ri-error-warning-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-error-warning-line' />
          <div className='label'>ri-error-warning-line</div>
        </div>
        <div className='icon'>
          <i className='ri-evernote-fill' />
          <div className='label'>ri-evernote-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-evernote-line' />
          <div className='label'>ri-evernote-line</div>
        </div>
        <div className='icon'>
          <i className='ri-exchange-box-fill' />
          <div className='label'>ri-exchange-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-exchange-box-line' />
          <div className='label'>ri-exchange-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-exchange-cny-fill' />
          <div className='label'>ri-exchange-cny-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-exchange-cny-line' />
          <div className='label'>ri-exchange-cny-line</div>
        </div>
        <div className='icon'>
          <i className='ri-exchange-dollar-fill' />
          <div className='label'>ri-exchange-dollar-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-exchange-dollar-line' />
          <div className='label'>ri-exchange-dollar-line</div>
        </div>
        <div className='icon'>
          <i className='ri-exchange-fill' />
          <div className='label'>ri-exchange-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-exchange-funds-fill' />
          <div className='label'>ri-exchange-funds-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-exchange-funds-line' />
          <div className='label'>ri-exchange-funds-line</div>
        </div>
        <div className='icon'>
          <i className='ri-exchange-line' />
          <div className='label'>ri-exchange-line</div>
        </div>
        <div className='icon'>
          <i className='ri-external-link-fill' />
          <div className='label'>ri-external-link-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-external-link-line' />
          <div className='label'>ri-external-link-line</div>
        </div>
        <div className='icon'>
          <i className='ri-eye-2-fill' />
          <div className='label'>ri-eye-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-eye-2-line' />
          <div className='label'>ri-eye-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-eye-close-fill' />
          <div className='label'>ri-eye-close-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-eye-close-line' />
          <div className='label'>ri-eye-close-line</div>
        </div>
        <div className='icon'>
          <i className='ri-eye-fill' />
          <div className='label'>ri-eye-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-eye-line' />
          <div className='label'>ri-eye-line</div>
        </div>
        <div className='icon'>
          <i className='ri-eye-off-fill' />
          <div className='label'>ri-eye-off-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-eye-off-line' />
          <div className='label'>ri-eye-off-line</div>
        </div>
        <div className='icon'>
          <i className='ri-facebook-box-fill' />
          <div className='label'>ri-facebook-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-facebook-box-line' />
          <div className='label'>ri-facebook-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-facebook-circle-fill' />
          <div className='label'>ri-facebook-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-facebook-circle-line' />
          <div className='label'>ri-facebook-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-facebook-fill' />
          <div className='label'>ri-facebook-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-facebook-line' />
          <div className='label'>ri-facebook-line</div>
        </div>
        <div className='icon'>
          <i className='ri-fahrenheit-fill' />
          <div className='label'>ri-fahrenheit-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-fahrenheit-line' />
          <div className='label'>ri-fahrenheit-line</div>
        </div>
        <div className='icon'>
          <i className='ri-feedback-fill' />
          <div className='label'>ri-feedback-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-feedback-line' />
          <div className='label'>ri-feedback-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-2-fill' />
          <div className='label'>ri-file-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-2-line' />
          <div className='label'>ri-file-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-3-fill' />
          <div className='label'>ri-file-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-3-line' />
          <div className='label'>ri-file-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-4-fill' />
          <div className='label'>ri-file-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-4-line' />
          <div className='label'>ri-file-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-add-fill' />
          <div className='label'>ri-file-add-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-add-line' />
          <div className='label'>ri-file-add-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-chart-2-fill' />
          <div className='label'>ri-file-chart-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-chart-2-line' />
          <div className='label'>ri-file-chart-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-chart-fill' />
          <div className='label'>ri-file-chart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-chart-line' />
          <div className='label'>ri-file-chart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-cloud-fill' />
          <div className='label'>ri-file-cloud-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-cloud-line' />
          <div className='label'>ri-file-cloud-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-code-fill' />
          <div className='label'>ri-file-code-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-code-line' />
          <div className='label'>ri-file-code-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-copy-2-fill' />
          <div className='label'>ri-file-copy-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-copy-2-line' />
          <div className='label'>ri-file-copy-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-copy-fill' />
          <div className='label'>ri-file-copy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-copy-line' />
          <div className='label'>ri-file-copy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-damage-fill' />
          <div className='label'>ri-file-damage-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-damage-line' />
          <div className='label'>ri-file-damage-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-download-fill' />
          <div className='label'>ri-file-download-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-download-line' />
          <div className='label'>ri-file-download-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-edit-fill' />
          <div className='label'>ri-file-edit-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-edit-line' />
          <div className='label'>ri-file-edit-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-excel-2-fill' />
          <div className='label'>ri-file-excel-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-excel-2-line' />
          <div className='label'>ri-file-excel-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-excel-fill' />
          <div className='label'>ri-file-excel-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-excel-line' />
          <div className='label'>ri-file-excel-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-fill' />
          <div className='label'>ri-file-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-forbid-fill' />
          <div className='label'>ri-file-forbid-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-forbid-line' />
          <div className='label'>ri-file-forbid-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-gif-fill' />
          <div className='label'>ri-file-gif-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-gif-line' />
          <div className='label'>ri-file-gif-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-history-fill' />
          <div className='label'>ri-file-history-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-history-line' />
          <div className='label'>ri-file-history-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-hwp-fill' />
          <div className='label'>ri-file-hwp-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-hwp-line' />
          <div className='label'>ri-file-hwp-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-info-fill' />
          <div className='label'>ri-file-info-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-info-line' />
          <div className='label'>ri-file-info-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-line' />
          <div className='label'>ri-file-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-list-2-fill' />
          <div className='label'>ri-file-list-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-list-2-line' />
          <div className='label'>ri-file-list-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-list-3-fill' />
          <div className='label'>ri-file-list-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-list-3-line' />
          <div className='label'>ri-file-list-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-list-fill' />
          <div className='label'>ri-file-list-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-list-line' />
          <div className='label'>ri-file-list-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-lock-fill' />
          <div className='label'>ri-file-lock-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-lock-line' />
          <div className='label'>ri-file-lock-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-mark-fill' />
          <div className='label'>ri-file-mark-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-mark-line' />
          <div className='label'>ri-file-mark-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-music-fill' />
          <div className='label'>ri-file-music-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-music-line' />
          <div className='label'>ri-file-music-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-paper-2-fill' />
          <div className='label'>ri-file-paper-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-paper-2-line' />
          <div className='label'>ri-file-paper-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-paper-fill' />
          <div className='label'>ri-file-paper-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-paper-line' />
          <div className='label'>ri-file-paper-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-pdf-fill' />
          <div className='label'>ri-file-pdf-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-pdf-line' />
          <div className='label'>ri-file-pdf-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-ppt-2-fill' />
          <div className='label'>ri-file-ppt-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-ppt-2-line' />
          <div className='label'>ri-file-ppt-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-ppt-fill' />
          <div className='label'>ri-file-ppt-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-ppt-line' />
          <div className='label'>ri-file-ppt-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-reduce-fill' />
          <div className='label'>ri-file-reduce-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-reduce-line' />
          <div className='label'>ri-file-reduce-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-search-fill' />
          <div className='label'>ri-file-search-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-search-line' />
          <div className='label'>ri-file-search-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-settings-fill' />
          <div className='label'>ri-file-settings-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-settings-line' />
          <div className='label'>ri-file-settings-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-shield-2-fill' />
          <div className='label'>ri-file-shield-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-shield-2-line' />
          <div className='label'>ri-file-shield-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-shield-fill' />
          <div className='label'>ri-file-shield-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-shield-line' />
          <div className='label'>ri-file-shield-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-shred-fill' />
          <div className='label'>ri-file-shred-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-shred-line' />
          <div className='label'>ri-file-shred-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-text-fill' />
          <div className='label'>ri-file-text-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-text-line' />
          <div className='label'>ri-file-text-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-transfer-fill' />
          <div className='label'>ri-file-transfer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-transfer-line' />
          <div className='label'>ri-file-transfer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-unknow-fill' />
          <div className='label'>ri-file-unknow-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-unknow-line' />
          <div className='label'>ri-file-unknow-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-upload-fill' />
          <div className='label'>ri-file-upload-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-upload-line' />
          <div className='label'>ri-file-upload-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-user-fill' />
          <div className='label'>ri-file-user-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-user-line' />
          <div className='label'>ri-file-user-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-warning-fill' />
          <div className='label'>ri-file-warning-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-warning-line' />
          <div className='label'>ri-file-warning-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-word-2-fill' />
          <div className='label'>ri-file-word-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-word-2-line' />
          <div className='label'>ri-file-word-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-word-fill' />
          <div className='label'>ri-file-word-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-word-line' />
          <div className='label'>ri-file-word-line</div>
        </div>
        <div className='icon'>
          <i className='ri-file-zip-fill' />
          <div className='label'>ri-file-zip-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-file-zip-line' />
          <div className='label'>ri-file-zip-line</div>
        </div>
        <div className='icon'>
          <i className='ri-film-fill' />
          <div className='label'>ri-film-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-film-line' />
          <div className='label'>ri-film-line</div>
        </div>
        <div className='icon'>
          <i className='ri-filter-2-fill' />
          <div className='label'>ri-filter-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-filter-2-line' />
          <div className='label'>ri-filter-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-filter-3-fill' />
          <div className='label'>ri-filter-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-filter-3-line' />
          <div className='label'>ri-filter-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-filter-fill' />
          <div className='label'>ri-filter-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-filter-line' />
          <div className='label'>ri-filter-line</div>
        </div>
        <div className='icon'>
          <i className='ri-filter-off-fill' />
          <div className='label'>ri-filter-off-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-filter-off-line' />
          <div className='label'>ri-filter-off-line</div>
        </div>
        <div className='icon'>
          <i className='ri-find-replace-fill' />
          <div className='label'>ri-find-replace-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-find-replace-line' />
          <div className='label'>ri-find-replace-line</div>
        </div>
        <div className='icon'>
          <i className='ri-finder-fill' />
          <div className='label'>ri-finder-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-finder-line' />
          <div className='label'>ri-finder-line</div>
        </div>
        <div className='icon'>
          <i className='ri-fingerprint-2-fill' />
          <div className='label'>ri-fingerprint-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-fingerprint-2-line' />
          <div className='label'>ri-fingerprint-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-fingerprint-fill' />
          <div className='label'>ri-fingerprint-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-fingerprint-line' />
          <div className='label'>ri-fingerprint-line</div>
        </div>
        <div className='icon'>
          <i className='ri-fire-fill' />
          <div className='label'>ri-fire-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-fire-line' />
          <div className='label'>ri-fire-line</div>
        </div>
        <div className='icon'>
          <i className='ri-firefox-fill' />
          <div className='label'>ri-firefox-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-firefox-line' />
          <div className='label'>ri-firefox-line</div>
        </div>
        <div className='icon'>
          <i className='ri-first-aid-kit-fill' />
          <div className='label'>ri-first-aid-kit-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-first-aid-kit-line' />
          <div className='label'>ri-first-aid-kit-line</div>
        </div>
        <div className='icon'>
          <i className='ri-flag-2-fill' />
          <div className='label'>ri-flag-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-flag-2-line' />
          <div className='label'>ri-flag-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-flag-fill' />
          <div className='label'>ri-flag-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-flag-line' />
          <div className='label'>ri-flag-line</div>
        </div>
        <div className='icon'>
          <i className='ri-flashlight-fill' />
          <div className='label'>ri-flashlight-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-flashlight-line' />
          <div className='label'>ri-flashlight-line</div>
        </div>
        <div className='icon'>
          <i className='ri-flask-fill' />
          <div className='label'>ri-flask-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-flask-line' />
          <div className='label'>ri-flask-line</div>
        </div>
        <div className='icon'>
          <i className='ri-flight-land-fill' />
          <div className='label'>ri-flight-land-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-flight-land-line' />
          <div className='label'>ri-flight-land-line</div>
        </div>
        <div className='icon'>
          <i className='ri-flight-takeoff-fill' />
          <div className='label'>ri-flight-takeoff-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-flight-takeoff-line' />
          <div className='label'>ri-flight-takeoff-line</div>
        </div>
        <div className='icon'>
          <i className='ri-flood-fill' />
          <div className='label'>ri-flood-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-flood-line' />
          <div className='label'>ri-flood-line</div>
        </div>
        <div className='icon'>
          <i className='ri-flow-chart' />
          <div className='label'>ri-flow-chart</div>
        </div>
        <div className='icon'>
          <i className='ri-flutter-fill' />
          <div className='label'>ri-flutter-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-flutter-line' />
          <div className='label'>ri-flutter-line</div>
        </div>
        <div className='icon'>
          <i className='ri-focus-2-fill' />
          <div className='label'>ri-focus-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-focus-2-line' />
          <div className='label'>ri-focus-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-focus-3-fill' />
          <div className='label'>ri-focus-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-focus-3-line' />
          <div className='label'>ri-focus-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-focus-fill' />
          <div className='label'>ri-focus-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-focus-line' />
          <div className='label'>ri-focus-line</div>
        </div>
        <div className='icon'>
          <i className='ri-foggy-fill' />
          <div className='label'>ri-foggy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-foggy-line' />
          <div className='label'>ri-foggy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-2-fill' />
          <div className='label'>ri-folder-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-2-line' />
          <div className='label'>ri-folder-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-3-fill' />
          <div className='label'>ri-folder-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-3-line' />
          <div className='label'>ri-folder-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-4-fill' />
          <div className='label'>ri-folder-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-4-line' />
          <div className='label'>ri-folder-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-5-fill' />
          <div className='label'>ri-folder-5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-5-line' />
          <div className='label'>ri-folder-5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-add-fill' />
          <div className='label'>ri-folder-add-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-add-line' />
          <div className='label'>ri-folder-add-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-chart-2-fill' />
          <div className='label'>ri-folder-chart-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-chart-2-line' />
          <div className='label'>ri-folder-chart-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-chart-fill' />
          <div className='label'>ri-folder-chart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-chart-line' />
          <div className='label'>ri-folder-chart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-download-fill' />
          <div className='label'>ri-folder-download-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-download-line' />
          <div className='label'>ri-folder-download-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-fill' />
          <div className='label'>ri-folder-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-forbid-fill' />
          <div className='label'>ri-folder-forbid-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-forbid-line' />
          <div className='label'>ri-folder-forbid-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-history-fill' />
          <div className='label'>ri-folder-history-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-history-line' />
          <div className='label'>ri-folder-history-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-info-fill' />
          <div className='label'>ri-folder-info-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-info-line' />
          <div className='label'>ri-folder-info-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-keyhole-fill' />
          <div className='label'>ri-folder-keyhole-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-keyhole-line' />
          <div className='label'>ri-folder-keyhole-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-line' />
          <div className='label'>ri-folder-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-lock-fill' />
          <div className='label'>ri-folder-lock-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-lock-line' />
          <div className='label'>ri-folder-lock-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-music-fill' />
          <div className='label'>ri-folder-music-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-music-line' />
          <div className='label'>ri-folder-music-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-open-fill' />
          <div className='label'>ri-folder-open-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-open-line' />
          <div className='label'>ri-folder-open-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-received-fill' />
          <div className='label'>ri-folder-received-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-received-line' />
          <div className='label'>ri-folder-received-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-reduce-fill' />
          <div className='label'>ri-folder-reduce-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-reduce-line' />
          <div className='label'>ri-folder-reduce-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-settings-fill' />
          <div className='label'>ri-folder-settings-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-settings-line' />
          <div className='label'>ri-folder-settings-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-shared-fill' />
          <div className='label'>ri-folder-shared-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-shared-line' />
          <div className='label'>ri-folder-shared-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-shield-2-fill' />
          <div className='label'>ri-folder-shield-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-shield-2-line' />
          <div className='label'>ri-folder-shield-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-shield-fill' />
          <div className='label'>ri-folder-shield-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-shield-line' />
          <div className='label'>ri-folder-shield-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-transfer-fill' />
          <div className='label'>ri-folder-transfer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-transfer-line' />
          <div className='label'>ri-folder-transfer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-unknow-fill' />
          <div className='label'>ri-folder-unknow-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-unknow-line' />
          <div className='label'>ri-folder-unknow-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-upload-fill' />
          <div className='label'>ri-folder-upload-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-upload-line' />
          <div className='label'>ri-folder-upload-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-user-fill' />
          <div className='label'>ri-folder-user-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-user-line' />
          <div className='label'>ri-folder-user-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-warning-fill' />
          <div className='label'>ri-folder-warning-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-warning-line' />
          <div className='label'>ri-folder-warning-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-zip-fill' />
          <div className='label'>ri-folder-zip-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folder-zip-line' />
          <div className='label'>ri-folder-zip-line</div>
        </div>
        <div className='icon'>
          <i className='ri-folders-fill' />
          <div className='label'>ri-folders-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-folders-line' />
          <div className='label'>ri-folders-line</div>
        </div>
        <div className='icon'>
          <i className='ri-font-color' />
          <div className='label'>ri-font-color</div>
        </div>
        <div className='icon'>
          <i className='ri-font-size-2' />
          <div className='label'>ri-font-size-2</div>
        </div>
        <div className='icon'>
          <i className='ri-font-size' />
          <div className='label'>ri-font-size</div>
        </div>
        <div className='icon'>
          <i className='ri-football-fill' />
          <div className='label'>ri-football-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-football-line' />
          <div className='label'>ri-football-line</div>
        </div>
        <div className='icon'>
          <i className='ri-footprint-fill' />
          <div className='label'>ri-footprint-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-footprint-line' />
          <div className='label'>ri-footprint-line</div>
        </div>
        <div className='icon'>
          <i className='ri-forbid-2-fill' />
          <div className='label'>ri-forbid-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-forbid-2-line' />
          <div className='label'>ri-forbid-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-forbid-fill' />
          <div className='label'>ri-forbid-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-forbid-line' />
          <div className='label'>ri-forbid-line</div>
        </div>
        <div className='icon'>
          <i className='ri-format-clear' />
          <div className='label'>ri-format-clear</div>
        </div>
        <div className='icon'>
          <i className='ri-fridge-fill' />
          <div className='label'>ri-fridge-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-fridge-line' />
          <div className='label'>ri-fridge-line</div>
        </div>
        <div className='icon'>
          <i className='ri-fullscreen-exit-fill' />
          <div className='label'>ri-fullscreen-exit-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-fullscreen-exit-line' />
          <div className='label'>ri-fullscreen-exit-line</div>
        </div>
        <div className='icon'>
          <i className='ri-fullscreen-fill' />
          <div className='label'>ri-fullscreen-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-fullscreen-line' />
          <div className='label'>ri-fullscreen-line</div>
        </div>
        <div className='icon'>
          <i className='ri-function-fill' />
          <div className='label'>ri-function-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-function-line' />
          <div className='label'>ri-function-line</div>
        </div>
        <div className='icon'>
          <i className='ri-functions' />
          <div className='label'>ri-functions</div>
        </div>
        <div className='icon'>
          <i className='ri-funds-box-fill' />
          <div className='label'>ri-funds-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-funds-box-line' />
          <div className='label'>ri-funds-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-funds-fill' />
          <div className='label'>ri-funds-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-funds-line' />
          <div className='label'>ri-funds-line</div>
        </div>
        <div className='icon'>
          <i className='ri-gallery-fill' />
          <div className='label'>ri-gallery-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-gallery-line' />
          <div className='label'>ri-gallery-line</div>
        </div>
        <div className='icon'>
          <i className='ri-gallery-upload-fill' />
          <div className='label'>ri-gallery-upload-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-gallery-upload-line' />
          <div className='label'>ri-gallery-upload-line</div>
        </div>
        <div className='icon'>
          <i className='ri-game-fill' />
          <div className='label'>ri-game-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-game-line' />
          <div className='label'>ri-game-line</div>
        </div>
        <div className='icon'>
          <i className='ri-gamepad-fill' />
          <div className='label'>ri-gamepad-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-gamepad-line' />
          <div className='label'>ri-gamepad-line</div>
        </div>
        <div className='icon'>
          <i className='ri-gas-station-fill' />
          <div className='label'>ri-gas-station-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-gas-station-line' />
          <div className='label'>ri-gas-station-line</div>
        </div>
        <div className='icon'>
          <i className='ri-gatsby-fill' />
          <div className='label'>ri-gatsby-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-gatsby-line' />
          <div className='label'>ri-gatsby-line</div>
        </div>
        <div className='icon'>
          <i className='ri-genderless-fill' />
          <div className='label'>ri-genderless-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-genderless-line' />
          <div className='label'>ri-genderless-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ghost-2-fill' />
          <div className='label'>ri-ghost-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ghost-2-line' />
          <div className='label'>ri-ghost-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ghost-fill' />
          <div className='label'>ri-ghost-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ghost-line' />
          <div className='label'>ri-ghost-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ghost-smile-fill' />
          <div className='label'>ri-ghost-smile-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ghost-smile-line' />
          <div className='label'>ri-ghost-smile-line</div>
        </div>
        <div className='icon'>
          <i className='ri-gift-2-fill' />
          <div className='label'>ri-gift-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-gift-2-line' />
          <div className='label'>ri-gift-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-gift-fill' />
          <div className='label'>ri-gift-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-gift-line' />
          <div className='label'>ri-gift-line</div>
        </div>
        <div className='icon'>
          <i className='ri-git-branch-fill' />
          <div className='label'>ri-git-branch-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-git-branch-line' />
          <div className='label'>ri-git-branch-line</div>
        </div>
        <div className='icon'>
          <i className='ri-git-commit-fill' />
          <div className='label'>ri-git-commit-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-git-commit-line' />
          <div className='label'>ri-git-commit-line</div>
        </div>
        <div className='icon'>
          <i className='ri-git-merge-fill' />
          <div className='label'>ri-git-merge-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-git-merge-line' />
          <div className='label'>ri-git-merge-line</div>
        </div>
        <div className='icon'>
          <i className='ri-git-pull-request-fill' />
          <div className='label'>ri-git-pull-request-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-git-pull-request-line' />
          <div className='label'>ri-git-pull-request-line</div>
        </div>
        <div className='icon'>
          <i className='ri-git-repository-commits-fill' />
          <div className='label'>ri-git-repository-commits-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-git-repository-commits-line' />
          <div className='label'>ri-git-repository-commits-line</div>
        </div>
        <div className='icon'>
          <i className='ri-git-repository-fill' />
          <div className='label'>ri-git-repository-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-git-repository-line' />
          <div className='label'>ri-git-repository-line</div>
        </div>
        <div className='icon'>
          <i className='ri-git-repository-private-fill' />
          <div className='label'>ri-git-repository-private-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-git-repository-private-line' />
          <div className='label'>ri-git-repository-private-line</div>
        </div>
        <div className='icon'>
          <i className='ri-github-fill' />
          <div className='label'>ri-github-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-github-line' />
          <div className='label'>ri-github-line</div>
        </div>
        <div className='icon'>
          <i className='ri-gitlab-fill' />
          <div className='label'>ri-gitlab-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-gitlab-line' />
          <div className='label'>ri-gitlab-line</div>
        </div>
        <div className='icon'>
          <i className='ri-global-fill' />
          <div className='label'>ri-global-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-global-line' />
          <div className='label'>ri-global-line</div>
        </div>
        <div className='icon'>
          <i className='ri-globe-fill' />
          <div className='label'>ri-globe-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-globe-line' />
          <div className='label'>ri-globe-line</div>
        </div>
        <div className='icon'>
          <i className='ri-goblet-fill' />
          <div className='label'>ri-goblet-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-goblet-line' />
          <div className='label'>ri-goblet-line</div>
        </div>
        <div className='icon'>
          <i className='ri-google-fill' />
          <div className='label'>ri-google-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-google-line' />
          <div className='label'>ri-google-line</div>
        </div>
        <div className='icon'>
          <i className='ri-google-play-fill' />
          <div className='label'>ri-google-play-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-google-play-line' />
          <div className='label'>ri-google-play-line</div>
        </div>
        <div className='icon'>
          <i className='ri-government-fill' />
          <div className='label'>ri-government-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-government-line' />
          <div className='label'>ri-government-line</div>
        </div>
        <div className='icon'>
          <i className='ri-gps-fill' />
          <div className='label'>ri-gps-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-gps-line' />
          <div className='label'>ri-gps-line</div>
        </div>
        <div className='icon'>
          <i className='ri-gradienter-fill' />
          <div className='label'>ri-gradienter-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-gradienter-line' />
          <div className='label'>ri-gradienter-line</div>
        </div>
        <div className='icon'>
          <i className='ri-grid-fill' />
          <div className='label'>ri-grid-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-grid-line' />
          <div className='label'>ri-grid-line</div>
        </div>
        <div className='icon'>
          <i className='ri-group-2-fill' />
          <div className='label'>ri-group-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-group-2-line' />
          <div className='label'>ri-group-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-group-fill' />
          <div className='label'>ri-group-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-group-line' />
          <div className='label'>ri-group-line</div>
        </div>
        <div className='icon'>
          <i className='ri-guide-fill' />
          <div className='label'>ri-guide-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-guide-line' />
          <div className='label'>ri-guide-line</div>
        </div>
        <div className='icon'>
          <i className='ri-h-1' />
          <div className='label'>ri-h-1</div>
        </div>
        <div className='icon'>
          <i className='ri-h-2' />
          <div className='label'>ri-h-2</div>
        </div>
        <div className='icon'>
          <i className='ri-h-3' />
          <div className='label'>ri-h-3</div>
        </div>
        <div className='icon'>
          <i className='ri-h-4' />
          <div className='label'>ri-h-4</div>
        </div>
        <div className='icon'>
          <i className='ri-h-5' />
          <div className='label'>ri-h-5</div>
        </div>
        <div className='icon'>
          <i className='ri-h-6' />
          <div className='label'>ri-h-6</div>
        </div>
        <div className='icon'>
          <i className='ri-hail-fill' />
          <div className='label'>ri-hail-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hail-line' />
          <div className='label'>ri-hail-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hammer-fill' />
          <div className='label'>ri-hammer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hammer-line' />
          <div className='label'>ri-hammer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hand-coin-fill' />
          <div className='label'>ri-hand-coin-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hand-coin-line' />
          <div className='label'>ri-hand-coin-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hand-heart-fill' />
          <div className='label'>ri-hand-heart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hand-heart-line' />
          <div className='label'>ri-hand-heart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hand-sanitizer-fill' />
          <div className='label'>ri-hand-sanitizer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hand-sanitizer-line' />
          <div className='label'>ri-hand-sanitizer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-handbag-fill' />
          <div className='label'>ri-handbag-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-handbag-line' />
          <div className='label'>ri-handbag-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hard-drive-2-fill' />
          <div className='label'>ri-hard-drive-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hard-drive-2-line' />
          <div className='label'>ri-hard-drive-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hard-drive-fill' />
          <div className='label'>ri-hard-drive-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hard-drive-line' />
          <div className='label'>ri-hard-drive-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hashtag' />
          <div className='label'>ri-hashtag</div>
        </div>
        <div className='icon'>
          <i className='ri-haze-2-fill' />
          <div className='label'>ri-haze-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-haze-2-line' />
          <div className='label'>ri-haze-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-haze-fill' />
          <div className='label'>ri-haze-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-haze-line' />
          <div className='label'>ri-haze-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hd-fill' />
          <div className='label'>ri-hd-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hd-line' />
          <div className='label'>ri-hd-line</div>
        </div>
        <div className='icon'>
          <i className='ri-heading' />
          <div className='label'>ri-heading</div>
        </div>
        <div className='icon'>
          <i className='ri-headphone-fill' />
          <div className='label'>ri-headphone-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-headphone-line' />
          <div className='label'>ri-headphone-line</div>
        </div>
        <div className='icon'>
          <i className='ri-health-book-fill' />
          <div className='label'>ri-health-book-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-health-book-line' />
          <div className='label'>ri-health-book-line</div>
        </div>
        <div className='icon'>
          <i className='ri-heart-2-fill' />
          <div className='label'>ri-heart-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-heart-2-line' />
          <div className='label'>ri-heart-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-heart-3-fill' />
          <div className='label'>ri-heart-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-heart-3-line' />
          <div className='label'>ri-heart-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-heart-add-fill' />
          <div className='label'>ri-heart-add-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-heart-add-line' />
          <div className='label'>ri-heart-add-line</div>
        </div>
        <div className='icon'>
          <i className='ri-heart-fill' />
          <div className='label'>ri-heart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-heart-line' />
          <div className='label'>ri-heart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-heart-pulse-fill' />
          <div className='label'>ri-heart-pulse-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-heart-pulse-line' />
          <div className='label'>ri-heart-pulse-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hearts-fill' />
          <div className='label'>ri-hearts-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hearts-line' />
          <div className='label'>ri-hearts-line</div>
        </div>
        <div className='icon'>
          <i className='ri-heavy-showers-fill' />
          <div className='label'>ri-heavy-showers-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-heavy-showers-line' />
          <div className='label'>ri-heavy-showers-line</div>
        </div>
        <div className='icon'>
          <i className='ri-history-fill' />
          <div className='label'>ri-history-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-history-line' />
          <div className='label'>ri-history-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-2-fill' />
          <div className='label'>ri-home-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-2-line' />
          <div className='label'>ri-home-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-3-fill' />
          <div className='label'>ri-home-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-3-line' />
          <div className='label'>ri-home-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-4-fill' />
          <div className='label'>ri-home-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-4-line' />
          <div className='label'>ri-home-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-5-fill' />
          <div className='label'>ri-home-5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-5-line' />
          <div className='label'>ri-home-5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-6-fill' />
          <div className='label'>ri-home-6-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-6-line' />
          <div className='label'>ri-home-6-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-7-fill' />
          <div className='label'>ri-home-7-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-7-line' />
          <div className='label'>ri-home-7-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-8-fill' />
          <div className='label'>ri-home-8-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-8-line' />
          <div className='label'>ri-home-8-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-fill' />
          <div className='label'>ri-home-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-gear-fill' />
          <div className='label'>ri-home-gear-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-gear-line' />
          <div className='label'>ri-home-gear-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-heart-fill' />
          <div className='label'>ri-home-heart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-heart-line' />
          <div className='label'>ri-home-heart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-line' />
          <div className='label'>ri-home-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-smile-2-fill' />
          <div className='label'>ri-home-smile-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-smile-2-line' />
          <div className='label'>ri-home-smile-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-smile-fill' />
          <div className='label'>ri-home-smile-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-smile-line' />
          <div className='label'>ri-home-smile-line</div>
        </div>
        <div className='icon'>
          <i className='ri-home-wifi-fill' />
          <div className='label'>ri-home-wifi-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-home-wifi-line' />
          <div className='label'>ri-home-wifi-line</div>
        </div>
        <div className='icon'>
          <i className='ri-honor-of-kings-fill' />
          <div className='label'>ri-honor-of-kings-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-honor-of-kings-line' />
          <div className='label'>ri-honor-of-kings-line</div>
        </div>
        <div className='icon'>
          <i className='ri-honour-fill' />
          <div className='label'>ri-honour-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-honour-line' />
          <div className='label'>ri-honour-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hospital-fill' />
          <div className='label'>ri-hospital-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hospital-line' />
          <div className='label'>ri-hospital-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hotel-bed-fill' />
          <div className='label'>ri-hotel-bed-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hotel-bed-line' />
          <div className='label'>ri-hotel-bed-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hotel-fill' />
          <div className='label'>ri-hotel-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hotel-line' />
          <div className='label'>ri-hotel-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hotspot-fill' />
          <div className='label'>ri-hotspot-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hotspot-line' />
          <div className='label'>ri-hotspot-line</div>
        </div>
        <div className='icon'>
          <i className='ri-hq-fill' />
          <div className='label'>ri-hq-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-hq-line' />
          <div className='label'>ri-hq-line</div>
        </div>
        <div className='icon'>
          <i className='ri-html5-fill' />
          <div className='label'>ri-html5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-html5-line' />
          <div className='label'>ri-html5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ie-fill' />
          <div className='label'>ri-ie-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ie-line' />
          <div className='label'>ri-ie-line</div>
        </div>
        <div className='icon'>
          <i className='ri-image-2-fill' />
          <div className='label'>ri-image-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-image-2-line' />
          <div className='label'>ri-image-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-image-add-fill' />
          <div className='label'>ri-image-add-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-image-add-line' />
          <div className='label'>ri-image-add-line</div>
        </div>
        <div className='icon'>
          <i className='ri-image-edit-fill' />
          <div className='label'>ri-image-edit-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-image-edit-line' />
          <div className='label'>ri-image-edit-line</div>
        </div>
        <div className='icon'>
          <i className='ri-image-fill' />
          <div className='label'>ri-image-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-image-line' />
          <div className='label'>ri-image-line</div>
        </div>
        <div className='icon'>
          <i className='ri-inbox-archive-fill' />
          <div className='label'>ri-inbox-archive-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-inbox-archive-line' />
          <div className='label'>ri-inbox-archive-line</div>
        </div>
        <div className='icon'>
          <i className='ri-inbox-fill' />
          <div className='label'>ri-inbox-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-inbox-line' />
          <div className='label'>ri-inbox-line</div>
        </div>
        <div className='icon'>
          <i className='ri-inbox-unarchive-fill' />
          <div className='label'>ri-inbox-unarchive-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-inbox-unarchive-line' />
          <div className='label'>ri-inbox-unarchive-line</div>
        </div>
        <div className='icon'>
          <i className='ri-increase-decrease-fill' />
          <div className='label'>ri-increase-decrease-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-increase-decrease-line' />
          <div className='label'>ri-increase-decrease-line</div>
        </div>
        <div className='icon'>
          <i className='ri-indent-decrease' />
          <div className='label'>ri-indent-decrease</div>
        </div>
        <div className='icon'>
          <i className='ri-indent-increase' />
          <div className='label'>ri-indent-increase</div>
        </div>
        <div className='icon'>
          <i className='ri-indeterminate-circle-fill' />
          <div className='label'>ri-indeterminate-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-indeterminate-circle-line' />
          <div className='label'>ri-indeterminate-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-information-fill' />
          <div className='label'>ri-information-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-information-line' />
          <div className='label'>ri-information-line</div>
        </div>
        <div className='icon'>
          <i className='ri-infrared-thermometer-fill' />
          <div className='label'>ri-infrared-thermometer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-infrared-thermometer-line' />
          <div className='label'>ri-infrared-thermometer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ink-bottle-fill' />
          <div className='label'>ri-ink-bottle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ink-bottle-line' />
          <div className='label'>ri-ink-bottle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-input-cursor-move' />
          <div className='label'>ri-input-cursor-move</div>
        </div>
        <div className='icon'>
          <i className='ri-input-method-fill' />
          <div className='label'>ri-input-method-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-input-method-line' />
          <div className='label'>ri-input-method-line</div>
        </div>
        <div className='icon'>
          <i className='ri-insert-column-left' />
          <div className='label'>ri-insert-column-left</div>
        </div>
        <div className='icon'>
          <i className='ri-insert-column-right' />
          <div className='label'>ri-insert-column-right</div>
        </div>
        <div className='icon'>
          <i className='ri-insert-row-bottom' />
          <div className='label'>ri-insert-row-bottom</div>
        </div>
        <div className='icon'>
          <i className='ri-insert-row-top' />
          <div className='label'>ri-insert-row-top</div>
        </div>
        <div className='icon'>
          <i className='ri-instagram-fill' />
          <div className='label'>ri-instagram-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-instagram-line' />
          <div className='label'>ri-instagram-line</div>
        </div>
        <div className='icon'>
          <i className='ri-install-fill' />
          <div className='label'>ri-install-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-install-line' />
          <div className='label'>ri-install-line</div>
        </div>
        <div className='icon'>
          <i className='ri-invision-fill' />
          <div className='label'>ri-invision-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-invision-line' />
          <div className='label'>ri-invision-line</div>
        </div>
        <div className='icon'>
          <i className='ri-italic' />
          <div className='label'>ri-italic</div>
        </div>
        <div className='icon'>
          <i className='ri-kakao-talk-fill' />
          <div className='label'>ri-kakao-talk-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-kakao-talk-line' />
          <div className='label'>ri-kakao-talk-line</div>
        </div>
        <div className='icon'>
          <i className='ri-key-2-fill' />
          <div className='label'>ri-key-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-key-2-line' />
          <div className='label'>ri-key-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-key-fill' />
          <div className='label'>ri-key-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-key-line' />
          <div className='label'>ri-key-line</div>
        </div>
        <div className='icon'>
          <i className='ri-keyboard-box-fill' />
          <div className='label'>ri-keyboard-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-keyboard-box-line' />
          <div className='label'>ri-keyboard-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-keyboard-fill' />
          <div className='label'>ri-keyboard-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-keyboard-line' />
          <div className='label'>ri-keyboard-line</div>
        </div>
        <div className='icon'>
          <i className='ri-keynote-fill' />
          <div className='label'>ri-keynote-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-keynote-line' />
          <div className='label'>ri-keynote-line</div>
        </div>
        <div className='icon'>
          <i className='ri-knife-blood-fill' />
          <div className='label'>ri-knife-blood-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-knife-blood-line' />
          <div className='label'>ri-knife-blood-line</div>
        </div>
        <div className='icon'>
          <i className='ri-knife-fill' />
          <div className='label'>ri-knife-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-knife-line' />
          <div className='label'>ri-knife-line</div>
        </div>
        <div className='icon'>
          <i className='ri-landscape-fill' />
          <div className='label'>ri-landscape-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-landscape-line' />
          <div className='label'>ri-landscape-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-2-fill' />
          <div className='label'>ri-layout-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-2-line' />
          <div className='label'>ri-layout-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-3-fill' />
          <div className='label'>ri-layout-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-3-line' />
          <div className='label'>ri-layout-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-4-fill' />
          <div className='label'>ri-layout-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-4-line' />
          <div className='label'>ri-layout-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-5-fill' />
          <div className='label'>ri-layout-5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-5-line' />
          <div className='label'>ri-layout-5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-6-fill' />
          <div className='label'>ri-layout-6-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-6-line' />
          <div className='label'>ri-layout-6-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-bottom-2-fill' />
          <div className='label'>ri-layout-bottom-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-bottom-2-line' />
          <div className='label'>ri-layout-bottom-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-bottom-fill' />
          <div className='label'>ri-layout-bottom-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-bottom-line' />
          <div className='label'>ri-layout-bottom-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-column-fill' />
          <div className='label'>ri-layout-column-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-column-line' />
          <div className='label'>ri-layout-column-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-fill' />
          <div className='label'>ri-layout-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-grid-fill' />
          <div className='label'>ri-layout-grid-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-grid-line' />
          <div className='label'>ri-layout-grid-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-left-2-fill' />
          <div className='label'>ri-layout-left-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-left-2-line' />
          <div className='label'>ri-layout-left-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-left-fill' />
          <div className='label'>ri-layout-left-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-left-line' />
          <div className='label'>ri-layout-left-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-line' />
          <div className='label'>ri-layout-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-masonry-fill' />
          <div className='label'>ri-layout-masonry-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-masonry-line' />
          <div className='label'>ri-layout-masonry-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-right-2-fill' />
          <div className='label'>ri-layout-right-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-right-2-line' />
          <div className='label'>ri-layout-right-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-right-fill' />
          <div className='label'>ri-layout-right-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-right-line' />
          <div className='label'>ri-layout-right-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-row-fill' />
          <div className='label'>ri-layout-row-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-row-line' />
          <div className='label'>ri-layout-row-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-top-2-fill' />
          <div className='label'>ri-layout-top-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-top-2-line' />
          <div className='label'>ri-layout-top-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-top-fill' />
          <div className='label'>ri-layout-top-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-layout-top-line' />
          <div className='label'>ri-layout-top-line</div>
        </div>
        <div className='icon'>
          <i className='ri-leaf-fill' />
          <div className='label'>ri-leaf-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-leaf-line' />
          <div className='label'>ri-leaf-line</div>
        </div>
        <div className='icon'>
          <i className='ri-lifebuoy-fill' />
          <div className='label'>ri-lifebuoy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-lifebuoy-line' />
          <div className='label'>ri-lifebuoy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-lightbulb-fill' />
          <div className='label'>ri-lightbulb-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-lightbulb-flash-fill' />
          <div className='label'>ri-lightbulb-flash-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-lightbulb-flash-line' />
          <div className='label'>ri-lightbulb-flash-line</div>
        </div>
        <div className='icon'>
          <i className='ri-lightbulb-line' />
          <div className='label'>ri-lightbulb-line</div>
        </div>
        <div className='icon'>
          <i className='ri-line-chart-fill' />
          <div className='label'>ri-line-chart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-line-chart-line' />
          <div className='label'>ri-line-chart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-line-fill' />
          <div className='label'>ri-line-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-line-height' />
          <div className='label'>ri-line-height</div>
        </div>
        <div className='icon'>
          <i className='ri-line-line' />
          <div className='label'>ri-line-line</div>
        </div>
        <div className='icon'>
          <i className='ri-link-m' />
          <div className='label'>ri-link-m</div>
        </div>
        <div className='icon'>
          <i className='ri-link-unlink-m' />
          <div className='label'>ri-link-unlink-m</div>
        </div>
        <div className='icon'>
          <i className='ri-link-unlink' />
          <div className='label'>ri-link-unlink</div>
        </div>
        <div className='icon'>
          <i className='ri-link' />
          <div className='label'>ri-link</div>
        </div>
        <div className='icon'>
          <i className='ri-linkedin-box-fill' />
          <div className='label'>ri-linkedin-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-linkedin-box-line' />
          <div className='label'>ri-linkedin-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-linkedin-fill' />
          <div className='label'>ri-linkedin-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-linkedin-line' />
          <div className='label'>ri-linkedin-line</div>
        </div>
        <div className='icon'>
          <i className='ri-links-fill' />
          <div className='label'>ri-links-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-links-line' />
          <div className='label'>ri-links-line</div>
        </div>
        <div className='icon'>
          <i className='ri-list-check-2' />
          <div className='label'>ri-list-check-2</div>
        </div>
        <div className='icon'>
          <i className='ri-list-check' />
          <div className='label'>ri-list-check</div>
        </div>
        <div className='icon'>
          <i className='ri-list-ordered' />
          <div className='label'>ri-list-ordered</div>
        </div>
        <div className='icon'>
          <i className='ri-list-settings-fill' />
          <div className='label'>ri-list-settings-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-list-settings-line' />
          <div className='label'>ri-list-settings-line</div>
        </div>
        <div className='icon'>
          <i className='ri-list-unordered' />
          <div className='label'>ri-list-unordered</div>
        </div>
        <div className='icon'>
          <i className='ri-live-fill' />
          <div className='label'>ri-live-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-live-line' />
          <div className='label'>ri-live-line</div>
        </div>
        <div className='icon'>
          <i className='ri-loader-2-fill' />
          <div className='label'>ri-loader-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-loader-2-line' />
          <div className='label'>ri-loader-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-loader-3-fill' />
          <div className='label'>ri-loader-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-loader-3-line' />
          <div className='label'>ri-loader-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-loader-4-fill' />
          <div className='label'>ri-loader-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-loader-4-line' />
          <div className='label'>ri-loader-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-loader-5-fill' />
          <div className='label'>ri-loader-5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-loader-5-line' />
          <div className='label'>ri-loader-5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-loader-fill' />
          <div className='label'>ri-loader-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-loader-line' />
          <div className='label'>ri-loader-line</div>
        </div>
        <div className='icon'>
          <i className='ri-lock-2-fill' />
          <div className='label'>ri-lock-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-lock-2-line' />
          <div className='label'>ri-lock-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-lock-fill' />
          <div className='label'>ri-lock-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-lock-line' />
          <div className='label'>ri-lock-line</div>
        </div>
        <div className='icon'>
          <i className='ri-lock-password-fill' />
          <div className='label'>ri-lock-password-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-lock-password-line' />
          <div className='label'>ri-lock-password-line</div>
        </div>
        <div className='icon'>
          <i className='ri-lock-unlock-fill' />
          <div className='label'>ri-lock-unlock-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-lock-unlock-line' />
          <div className='label'>ri-lock-unlock-line</div>
        </div>
        <div className='icon'>
          <i className='ri-login-box-fill' />
          <div className='label'>ri-login-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-login-box-line' />
          <div className='label'>ri-login-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-login-circle-fill' />
          <div className='label'>ri-login-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-login-circle-line' />
          <div className='label'>ri-login-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-logout-box-fill' />
          <div className='label'>ri-logout-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-logout-box-line' />
          <div className='label'>ri-logout-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-logout-box-r-fill' />
          <div className='label'>ri-logout-box-r-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-logout-box-r-line' />
          <div className='label'>ri-logout-box-r-line</div>
        </div>
        <div className='icon'>
          <i className='ri-logout-circle-fill' />
          <div className='label'>ri-logout-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-logout-circle-line' />
          <div className='label'>ri-logout-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-logout-circle-r-fill' />
          <div className='label'>ri-logout-circle-r-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-logout-circle-r-line' />
          <div className='label'>ri-logout-circle-r-line</div>
        </div>
        <div className='icon'>
          <i className='ri-luggage-cart-fill' />
          <div className='label'>ri-luggage-cart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-luggage-cart-line' />
          <div className='label'>ri-luggage-cart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-luggage-deposit-fill' />
          <div className='label'>ri-luggage-deposit-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-luggage-deposit-line' />
          <div className='label'>ri-luggage-deposit-line</div>
        </div>
        <div className='icon'>
          <i className='ri-lungs-fill' />
          <div className='label'>ri-lungs-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-lungs-line' />
          <div className='label'>ri-lungs-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mac-fill' />
          <div className='label'>ri-mac-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mac-line' />
          <div className='label'>ri-mac-line</div>
        </div>
        <div className='icon'>
          <i className='ri-macbook-fill' />
          <div className='label'>ri-macbook-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-macbook-line' />
          <div className='label'>ri-macbook-line</div>
        </div>
        <div className='icon'>
          <i className='ri-magic-fill' />
          <div className='label'>ri-magic-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-magic-line' />
          <div className='label'>ri-magic-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-add-fill' />
          <div className='label'>ri-mail-add-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-add-line' />
          <div className='label'>ri-mail-add-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-check-fill' />
          <div className='label'>ri-mail-check-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-check-line' />
          <div className='label'>ri-mail-check-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-close-fill' />
          <div className='label'>ri-mail-close-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-close-line' />
          <div className='label'>ri-mail-close-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-download-fill' />
          <div className='label'>ri-mail-download-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-download-line' />
          <div className='label'>ri-mail-download-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-fill' />
          <div className='label'>ri-mail-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-forbid-fill' />
          <div className='label'>ri-mail-forbid-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-forbid-line' />
          <div className='label'>ri-mail-forbid-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-line' />
          <div className='label'>ri-mail-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-lock-fill' />
          <div className='label'>ri-mail-lock-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-lock-line' />
          <div className='label'>ri-mail-lock-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-open-fill' />
          <div className='label'>ri-mail-open-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-open-line' />
          <div className='label'>ri-mail-open-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-send-fill' />
          <div className='label'>ri-mail-send-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-send-line' />
          <div className='label'>ri-mail-send-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-settings-fill' />
          <div className='label'>ri-mail-settings-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-settings-line' />
          <div className='label'>ri-mail-settings-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-star-fill' />
          <div className='label'>ri-mail-star-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-star-line' />
          <div className='label'>ri-mail-star-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-unread-fill' />
          <div className='label'>ri-mail-unread-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-unread-line' />
          <div className='label'>ri-mail-unread-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-volume-fill' />
          <div className='label'>ri-mail-volume-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mail-volume-line' />
          <div className='label'>ri-mail-volume-line</div>
        </div>
        <div className='icon'>
          <i className='ri-map-2-fill' />
          <div className='label'>ri-map-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-map-2-line' />
          <div className='label'>ri-map-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-map-fill' />
          <div className='label'>ri-map-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-map-line' />
          <div className='label'>ri-map-line</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-2-fill' />
          <div className='label'>ri-map-pin-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-2-line' />
          <div className='label'>ri-map-pin-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-3-fill' />
          <div className='label'>ri-map-pin-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-3-line' />
          <div className='label'>ri-map-pin-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-4-fill' />
          <div className='label'>ri-map-pin-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-4-line' />
          <div className='label'>ri-map-pin-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-5-fill' />
          <div className='label'>ri-map-pin-5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-5-line' />
          <div className='label'>ri-map-pin-5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-add-fill' />
          <div className='label'>ri-map-pin-add-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-add-line' />
          <div className='label'>ri-map-pin-add-line</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-fill' />
          <div className='label'>ri-map-pin-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-line' />
          <div className='label'>ri-map-pin-line</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-range-fill' />
          <div className='label'>ri-map-pin-range-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-range-line' />
          <div className='label'>ri-map-pin-range-line</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-time-fill' />
          <div className='label'>ri-map-pin-time-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-time-line' />
          <div className='label'>ri-map-pin-time-line</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-user-fill' />
          <div className='label'>ri-map-pin-user-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-map-pin-user-line' />
          <div className='label'>ri-map-pin-user-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mark-pen-fill' />
          <div className='label'>ri-mark-pen-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mark-pen-line' />
          <div className='label'>ri-mark-pen-line</div>
        </div>
        <div className='icon'>
          <i className='ri-markdown-fill' />
          <div className='label'>ri-markdown-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-markdown-line' />
          <div className='label'>ri-markdown-line</div>
        </div>
        <div className='icon'>
          <i className='ri-markup-fill' />
          <div className='label'>ri-markup-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-markup-line' />
          <div className='label'>ri-markup-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mastercard-fill' />
          <div className='label'>ri-mastercard-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mastercard-line' />
          <div className='label'>ri-mastercard-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mastodon-fill' />
          <div className='label'>ri-mastodon-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mastodon-line' />
          <div className='label'>ri-mastodon-line</div>
        </div>
        <div className='icon'>
          <i className='ri-medal-2-fill' />
          <div className='label'>ri-medal-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-medal-2-line' />
          <div className='label'>ri-medal-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-medal-fill' />
          <div className='label'>ri-medal-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-medal-line' />
          <div className='label'>ri-medal-line</div>
        </div>
        <div className='icon'>
          <i className='ri-medicine-bottle-fill' />
          <div className='label'>ri-medicine-bottle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-medicine-bottle-line' />
          <div className='label'>ri-medicine-bottle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-medium-fill' />
          <div className='label'>ri-medium-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-medium-line' />
          <div className='label'>ri-medium-line</div>
        </div>
        <div className='icon'>
          <i className='ri-men-fill' />
          <div className='label'>ri-men-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-men-line' />
          <div className='label'>ri-men-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mental-health-fill' />
          <div className='label'>ri-mental-health-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mental-health-line' />
          <div className='label'>ri-mental-health-line</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-2-fill' />
          <div className='label'>ri-menu-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-2-line' />
          <div className='label'>ri-menu-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-3-fill' />
          <div className='label'>ri-menu-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-3-line' />
          <div className='label'>ri-menu-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-4-fill' />
          <div className='label'>ri-menu-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-4-line' />
          <div className='label'>ri-menu-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-5-fill' />
          <div className='label'>ri-menu-5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-5-line' />
          <div className='label'>ri-menu-5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-add-fill' />
          <div className='label'>ri-menu-add-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-add-line' />
          <div className='label'>ri-menu-add-line</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-fill' />
          <div className='label'>ri-menu-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-fold-fill' />
          <div className='label'>ri-menu-fold-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-fold-line' />
          <div className='label'>ri-menu-fold-line</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-line' />
          <div className='label'>ri-menu-line</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-unfold-fill' />
          <div className='label'>ri-menu-unfold-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-menu-unfold-line' />
          <div className='label'>ri-menu-unfold-line</div>
        </div>
        <div className='icon'>
          <i className='ri-merge-cells-horizontal' />
          <div className='label'>ri-merge-cells-horizontal</div>
        </div>
        <div className='icon'>
          <i className='ri-merge-cells-vertical' />
          <div className='label'>ri-merge-cells-vertical</div>
        </div>
        <div className='icon'>
          <i className='ri-message-2-fill' />
          <div className='label'>ri-message-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-message-2-line' />
          <div className='label'>ri-message-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-message-3-fill' />
          <div className='label'>ri-message-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-message-3-line' />
          <div className='label'>ri-message-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-message-fill' />
          <div className='label'>ri-message-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-message-line' />
          <div className='label'>ri-message-line</div>
        </div>
        <div className='icon'>
          <i className='ri-messenger-fill' />
          <div className='label'>ri-messenger-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-messenger-line' />
          <div className='label'>ri-messenger-line</div>
        </div>
        <div className='icon'>
          <i className='ri-meteor-fill' />
          <div className='label'>ri-meteor-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-meteor-line' />
          <div className='label'>ri-meteor-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mic-2-fill' />
          <div className='label'>ri-mic-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mic-2-line' />
          <div className='label'>ri-mic-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mic-fill' />
          <div className='label'>ri-mic-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mic-line' />
          <div className='label'>ri-mic-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mic-off-fill' />
          <div className='label'>ri-mic-off-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mic-off-line' />
          <div className='label'>ri-mic-off-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mickey-fill' />
          <div className='label'>ri-mickey-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mickey-line' />
          <div className='label'>ri-mickey-line</div>
        </div>
        <div className='icon'>
          <i className='ri-microscope-fill' />
          <div className='label'>ri-microscope-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-microscope-line' />
          <div className='label'>ri-microscope-line</div>
        </div>
        <div className='icon'>
          <i className='ri-microsoft-fill' />
          <div className='label'>ri-microsoft-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-microsoft-line' />
          <div className='label'>ri-microsoft-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mind-map' />
          <div className='label'>ri-mind-map</div>
        </div>
        <div className='icon'>
          <i className='ri-mini-program-fill' />
          <div className='label'>ri-mini-program-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mini-program-line' />
          <div className='label'>ri-mini-program-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mist-fill' />
          <div className='label'>ri-mist-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mist-line' />
          <div className='label'>ri-mist-line</div>
        </div>
        <div className='icon'>
          <i className='ri-money-cny-box-fill' />
          <div className='label'>ri-money-cny-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-money-cny-box-line' />
          <div className='label'>ri-money-cny-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-money-cny-circle-fill' />
          <div className='label'>ri-money-cny-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-money-cny-circle-line' />
          <div className='label'>ri-money-cny-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-money-dollar-box-fill' />
          <div className='label'>ri-money-dollar-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-money-dollar-box-line' />
          <div className='label'>ri-money-dollar-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-money-dollar-circle-fill' />
          <div className='label'>ri-money-dollar-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-money-dollar-circle-line' />
          <div className='label'>ri-money-dollar-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-money-euro-box-fill' />
          <div className='label'>ri-money-euro-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-money-euro-box-line' />
          <div className='label'>ri-money-euro-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-money-euro-circle-fill' />
          <div className='label'>ri-money-euro-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-money-euro-circle-line' />
          <div className='label'>ri-money-euro-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-money-pound-box-fill' />
          <div className='label'>ri-money-pound-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-money-pound-box-line' />
          <div className='label'>ri-money-pound-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-money-pound-circle-fill' />
          <div className='label'>ri-money-pound-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-money-pound-circle-line' />
          <div className='label'>ri-money-pound-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-moon-clear-fill' />
          <div className='label'>ri-moon-clear-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-moon-clear-line' />
          <div className='label'>ri-moon-clear-line</div>
        </div>
        <div className='icon'>
          <i className='ri-moon-cloudy-fill' />
          <div className='label'>ri-moon-cloudy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-moon-cloudy-line' />
          <div className='label'>ri-moon-cloudy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-moon-fill' />
          <div className='label'>ri-moon-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-moon-foggy-fill' />
          <div className='label'>ri-moon-foggy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-moon-foggy-line' />
          <div className='label'>ri-moon-foggy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-moon-line' />
          <div className='label'>ri-moon-line</div>
        </div>
        <div className='icon'>
          <i className='ri-more-2-fill' />
          <div className='label'>ri-more-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-more-2-line' />
          <div className='label'>ri-more-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-more-fill' />
          <div className='label'>ri-more-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-more-line' />
          <div className='label'>ri-more-line</div>
        </div>
        <div className='icon'>
          <i className='ri-motorbike-fill' />
          <div className='label'>ri-motorbike-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-motorbike-line' />
          <div className='label'>ri-motorbike-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mouse-fill' />
          <div className='label'>ri-mouse-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mouse-line' />
          <div className='label'>ri-mouse-line</div>
        </div>
        <div className='icon'>
          <i className='ri-movie-2-fill' />
          <div className='label'>ri-movie-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-movie-2-line' />
          <div className='label'>ri-movie-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-movie-fill' />
          <div className='label'>ri-movie-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-movie-line' />
          <div className='label'>ri-movie-line</div>
        </div>
        <div className='icon'>
          <i className='ri-music-2-fill' />
          <div className='label'>ri-music-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-music-2-line' />
          <div className='label'>ri-music-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-music-fill' />
          <div className='label'>ri-music-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-music-line' />
          <div className='label'>ri-music-line</div>
        </div>
        <div className='icon'>
          <i className='ri-mv-fill' />
          <div className='label'>ri-mv-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-mv-line' />
          <div className='label'>ri-mv-line</div>
        </div>
        <div className='icon'>
          <i className='ri-navigation-fill' />
          <div className='label'>ri-navigation-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-navigation-line' />
          <div className='label'>ri-navigation-line</div>
        </div>
        <div className='icon'>
          <i className='ri-netease-cloud-music-fill' />
          <div className='label'>ri-netease-cloud-music-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-netease-cloud-music-line' />
          <div className='label'>ri-netease-cloud-music-line</div>
        </div>
        <div className='icon'>
          <i className='ri-netflix-fill' />
          <div className='label'>ri-netflix-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-netflix-line' />
          <div className='label'>ri-netflix-line</div>
        </div>
        <div className='icon'>
          <i className='ri-newspaper-fill' />
          <div className='label'>ri-newspaper-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-newspaper-line' />
          <div className='label'>ri-newspaper-line</div>
        </div>
        <div className='icon'>
          <i className='ri-node-tree' />
          <div className='label'>ri-node-tree</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-2-fill' />
          <div className='label'>ri-notification-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-2-line' />
          <div className='label'>ri-notification-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-3-fill' />
          <div className='label'>ri-notification-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-3-line' />
          <div className='label'>ri-notification-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-4-fill' />
          <div className='label'>ri-notification-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-4-line' />
          <div className='label'>ri-notification-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-badge-fill' />
          <div className='label'>ri-notification-badge-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-badge-line' />
          <div className='label'>ri-notification-badge-line</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-fill' />
          <div className='label'>ri-notification-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-line' />
          <div className='label'>ri-notification-line</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-off-fill' />
          <div className='label'>ri-notification-off-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-notification-off-line' />
          <div className='label'>ri-notification-off-line</div>
        </div>
        <div className='icon'>
          <i className='ri-npmjs-fill' />
          <div className='label'>ri-npmjs-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-npmjs-line' />
          <div className='label'>ri-npmjs-line</div>
        </div>
        <div className='icon'>
          <i className='ri-number-0' />
          <div className='label'>ri-number-0</div>
        </div>
        <div className='icon'>
          <i className='ri-number-1' />
          <div className='label'>ri-number-1</div>
        </div>
        <div className='icon'>
          <i className='ri-number-2' />
          <div className='label'>ri-number-2</div>
        </div>
        <div className='icon'>
          <i className='ri-number-3' />
          <div className='label'>ri-number-3</div>
        </div>
        <div className='icon'>
          <i className='ri-number-4' />
          <div className='label'>ri-number-4</div>
        </div>
        <div className='icon'>
          <i className='ri-number-5' />
          <div className='label'>ri-number-5</div>
        </div>
        <div className='icon'>
          <i className='ri-number-6' />
          <div className='label'>ri-number-6</div>
        </div>
        <div className='icon'>
          <i className='ri-number-7' />
          <div className='label'>ri-number-7</div>
        </div>
        <div className='icon'>
          <i className='ri-number-8' />
          <div className='label'>ri-number-8</div>
        </div>
        <div className='icon'>
          <i className='ri-number-9' />
          <div className='label'>ri-number-9</div>
        </div>
        <div className='icon'>
          <i className='ri-numbers-fill' />
          <div className='label'>ri-numbers-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-numbers-line' />
          <div className='label'>ri-numbers-line</div>
        </div>
        <div className='icon'>
          <i className='ri-nurse-fill' />
          <div className='label'>ri-nurse-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-nurse-line' />
          <div className='label'>ri-nurse-line</div>
        </div>
        <div className='icon'>
          <i className='ri-oil-fill' />
          <div className='label'>ri-oil-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-oil-line' />
          <div className='label'>ri-oil-line</div>
        </div>
        <div className='icon'>
          <i className='ri-omega' />
          <div className='label'>ri-omega</div>
        </div>
        <div className='icon'>
          <i className='ri-open-arm-fill' />
          <div className='label'>ri-open-arm-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-open-arm-line' />
          <div className='label'>ri-open-arm-line</div>
        </div>
        <div className='icon'>
          <i className='ri-open-source-fill' />
          <div className='label'>ri-open-source-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-open-source-line' />
          <div className='label'>ri-open-source-line</div>
        </div>
        <div className='icon'>
          <i className='ri-opera-fill' />
          <div className='label'>ri-opera-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-opera-line' />
          <div className='label'>ri-opera-line</div>
        </div>
        <div className='icon'>
          <i className='ri-order-play-fill' />
          <div className='label'>ri-order-play-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-order-play-line' />
          <div className='label'>ri-order-play-line</div>
        </div>
        <div className='icon'>
          <i className='ri-organization-chart' />
          <div className='label'>ri-organization-chart</div>
        </div>
        <div className='icon'>
          <i className='ri-outlet-2-fill' />
          <div className='label'>ri-outlet-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-outlet-2-line' />
          <div className='label'>ri-outlet-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-outlet-fill' />
          <div className='label'>ri-outlet-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-outlet-line' />
          <div className='label'>ri-outlet-line</div>
        </div>
        <div className='icon'>
          <i className='ri-page-separator' />
          <div className='label'>ri-page-separator</div>
        </div>
        <div className='icon'>
          <i className='ri-pages-fill' />
          <div className='label'>ri-pages-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pages-line' />
          <div className='label'>ri-pages-line</div>
        </div>
        <div className='icon'>
          <i className='ri-paint-brush-fill' />
          <div className='label'>ri-paint-brush-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-paint-brush-line' />
          <div className='label'>ri-paint-brush-line</div>
        </div>
        <div className='icon'>
          <i className='ri-paint-fill' />
          <div className='label'>ri-paint-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-paint-line' />
          <div className='label'>ri-paint-line</div>
        </div>
        <div className='icon'>
          <i className='ri-palette-fill' />
          <div className='label'>ri-palette-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-palette-line' />
          <div className='label'>ri-palette-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pantone-fill' />
          <div className='label'>ri-pantone-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pantone-line' />
          <div className='label'>ri-pantone-line</div>
        </div>
        <div className='icon'>
          <i className='ri-paragraph' />
          <div className='label'>ri-paragraph</div>
        </div>
        <div className='icon'>
          <i className='ri-parent-fill' />
          <div className='label'>ri-parent-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-parent-line' />
          <div className='label'>ri-parent-line</div>
        </div>
        <div className='icon'>
          <i className='ri-parentheses-fill' />
          <div className='label'>ri-parentheses-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-parentheses-line' />
          <div className='label'>ri-parentheses-line</div>
        </div>
        <div className='icon'>
          <i className='ri-parking-box-fill' />
          <div className='label'>ri-parking-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-parking-box-line' />
          <div className='label'>ri-parking-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-parking-fill' />
          <div className='label'>ri-parking-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-parking-line' />
          <div className='label'>ri-parking-line</div>
        </div>
        <div className='icon'>
          <i className='ri-passport-fill' />
          <div className='label'>ri-passport-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-passport-line' />
          <div className='label'>ri-passport-line</div>
        </div>
        <div className='icon'>
          <i className='ri-patreon-fill' />
          <div className='label'>ri-patreon-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-patreon-line' />
          <div className='label'>ri-patreon-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pause-circle-fill' />
          <div className='label'>ri-pause-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pause-circle-line' />
          <div className='label'>ri-pause-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pause-fill' />
          <div className='label'>ri-pause-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pause-line' />
          <div className='label'>ri-pause-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pause-mini-fill' />
          <div className='label'>ri-pause-mini-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pause-mini-line' />
          <div className='label'>ri-pause-mini-line</div>
        </div>
        <div className='icon'>
          <i className='ri-paypal-fill' />
          <div className='label'>ri-paypal-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-paypal-line' />
          <div className='label'>ri-paypal-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pen-nib-fill' />
          <div className='label'>ri-pen-nib-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pen-nib-line' />
          <div className='label'>ri-pen-nib-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pencil-fill' />
          <div className='label'>ri-pencil-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pencil-line' />
          <div className='label'>ri-pencil-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pencil-ruler-2-fill' />
          <div className='label'>ri-pencil-ruler-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pencil-ruler-2-line' />
          <div className='label'>ri-pencil-ruler-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pencil-ruler-fill' />
          <div className='label'>ri-pencil-ruler-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pencil-ruler-line' />
          <div className='label'>ri-pencil-ruler-line</div>
        </div>
        <div className='icon'>
          <i className='ri-percent-fill' />
          <div className='label'>ri-percent-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-percent-line' />
          <div className='label'>ri-percent-line</div>
        </div>
        <div className='icon'>
          <i className='ri-phone-camera-fill' />
          <div className='label'>ri-phone-camera-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-phone-camera-line' />
          <div className='label'>ri-phone-camera-line</div>
        </div>
        <div className='icon'>
          <i className='ri-phone-fill' />
          <div className='label'>ri-phone-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-phone-find-fill' />
          <div className='label'>ri-phone-find-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-phone-find-line' />
          <div className='label'>ri-phone-find-line</div>
        </div>
        <div className='icon'>
          <i className='ri-phone-line' />
          <div className='label'>ri-phone-line</div>
        </div>
        <div className='icon'>
          <i className='ri-phone-lock-fill' />
          <div className='label'>ri-phone-lock-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-phone-lock-line' />
          <div className='label'>ri-phone-lock-line</div>
        </div>
        <div className='icon'>
          <i className='ri-picture-in-picture-2-fill' />
          <div className='label'>ri-picture-in-picture-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-picture-in-picture-2-line' />
          <div className='label'>ri-picture-in-picture-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-picture-in-picture-exit-fill' />
          <div className='label'>ri-picture-in-picture-exit-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-picture-in-picture-exit-line' />
          <div className='label'>ri-picture-in-picture-exit-line</div>
        </div>
        <div className='icon'>
          <i className='ri-picture-in-picture-fill' />
          <div className='label'>ri-picture-in-picture-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-picture-in-picture-line' />
          <div className='label'>ri-picture-in-picture-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pie-chart-2-fill' />
          <div className='label'>ri-pie-chart-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pie-chart-2-line' />
          <div className='label'>ri-pie-chart-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pie-chart-box-fill' />
          <div className='label'>ri-pie-chart-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pie-chart-box-line' />
          <div className='label'>ri-pie-chart-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pie-chart-fill' />
          <div className='label'>ri-pie-chart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pie-chart-line' />
          <div className='label'>ri-pie-chart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pin-distance-fill' />
          <div className='label'>ri-pin-distance-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pin-distance-line' />
          <div className='label'>ri-pin-distance-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ping-pong-fill' />
          <div className='label'>ri-ping-pong-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ping-pong-line' />
          <div className='label'>ri-ping-pong-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pinterest-fill' />
          <div className='label'>ri-pinterest-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pinterest-line' />
          <div className='label'>ri-pinterest-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pinyin-input' />
          <div className='label'>ri-pinyin-input</div>
        </div>
        <div className='icon'>
          <i className='ri-pixelfed-fill' />
          <div className='label'>ri-pixelfed-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pixelfed-line' />
          <div className='label'>ri-pixelfed-line</div>
        </div>
        <div className='icon'>
          <i className='ri-plane-fill' />
          <div className='label'>ri-plane-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-plane-line' />
          <div className='label'>ri-plane-line</div>
        </div>
        <div className='icon'>
          <i className='ri-plant-fill' />
          <div className='label'>ri-plant-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-plant-line' />
          <div className='label'>ri-plant-line</div>
        </div>
        <div className='icon'>
          <i className='ri-play-circle-fill' />
          <div className='label'>ri-play-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-play-circle-line' />
          <div className='label'>ri-play-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-play-fill' />
          <div className='label'>ri-play-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-play-line' />
          <div className='label'>ri-play-line</div>
        </div>
        <div className='icon'>
          <i className='ri-play-list-2-fill' />
          <div className='label'>ri-play-list-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-play-list-2-line' />
          <div className='label'>ri-play-list-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-play-list-add-fill' />
          <div className='label'>ri-play-list-add-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-play-list-add-line' />
          <div className='label'>ri-play-list-add-line</div>
        </div>
        <div className='icon'>
          <i className='ri-play-list-fill' />
          <div className='label'>ri-play-list-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-play-list-line' />
          <div className='label'>ri-play-list-line</div>
        </div>
        <div className='icon'>
          <i className='ri-play-mini-fill' />
          <div className='label'>ri-play-mini-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-play-mini-line' />
          <div className='label'>ri-play-mini-line</div>
        </div>
        <div className='icon'>
          <i className='ri-playstation-fill' />
          <div className='label'>ri-playstation-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-playstation-line' />
          <div className='label'>ri-playstation-line</div>
        </div>
        <div className='icon'>
          <i className='ri-plug-2-fill' />
          <div className='label'>ri-plug-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-plug-2-line' />
          <div className='label'>ri-plug-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-plug-fill' />
          <div className='label'>ri-plug-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-plug-line' />
          <div className='label'>ri-plug-line</div>
        </div>
        <div className='icon'>
          <i className='ri-polaroid-2-fill' />
          <div className='label'>ri-polaroid-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-polaroid-2-line' />
          <div className='label'>ri-polaroid-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-polaroid-fill' />
          <div className='label'>ri-polaroid-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-polaroid-line' />
          <div className='label'>ri-polaroid-line</div>
        </div>
        <div className='icon'>
          <i className='ri-police-car-fill' />
          <div className='label'>ri-police-car-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-police-car-line' />
          <div className='label'>ri-police-car-line</div>
        </div>
        <div className='icon'>
          <i className='ri-price-tag-2-fill' />
          <div className='label'>ri-price-tag-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-price-tag-2-line' />
          <div className='label'>ri-price-tag-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-price-tag-3-fill' />
          <div className='label'>ri-price-tag-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-price-tag-3-line' />
          <div className='label'>ri-price-tag-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-price-tag-fill' />
          <div className='label'>ri-price-tag-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-price-tag-line' />
          <div className='label'>ri-price-tag-line</div>
        </div>
        <div className='icon'>
          <i className='ri-printer-cloud-fill' />
          <div className='label'>ri-printer-cloud-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-printer-cloud-line' />
          <div className='label'>ri-printer-cloud-line</div>
        </div>
        <div className='icon'>
          <i className='ri-printer-fill' />
          <div className='label'>ri-printer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-printer-line' />
          <div className='label'>ri-printer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-product-hunt-fill' />
          <div className='label'>ri-product-hunt-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-product-hunt-line' />
          <div className='label'>ri-product-hunt-line</div>
        </div>
        <div className='icon'>
          <i className='ri-profile-fill' />
          <div className='label'>ri-profile-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-profile-line' />
          <div className='label'>ri-profile-line</div>
        </div>
        <div className='icon'>
          <i className='ri-projector-2-fill' />
          <div className='label'>ri-projector-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-projector-2-line' />
          <div className='label'>ri-projector-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-projector-fill' />
          <div className='label'>ri-projector-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-projector-line' />
          <div className='label'>ri-projector-line</div>
        </div>
        <div className='icon'>
          <i className='ri-psychotherapy-fill' />
          <div className='label'>ri-psychotherapy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-psychotherapy-line' />
          <div className='label'>ri-psychotherapy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pulse-fill' />
          <div className='label'>ri-pulse-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pulse-line' />
          <div className='label'>ri-pulse-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pushpin-2-fill' />
          <div className='label'>ri-pushpin-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pushpin-2-line' />
          <div className='label'>ri-pushpin-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-pushpin-fill' />
          <div className='label'>ri-pushpin-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-pushpin-line' />
          <div className='label'>ri-pushpin-line</div>
        </div>
        <div className='icon'>
          <i className='ri-qq-fill' />
          <div className='label'>ri-qq-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-qq-line' />
          <div className='label'>ri-qq-line</div>
        </div>
        <div className='icon'>
          <i className='ri-qr-code-fill' />
          <div className='label'>ri-qr-code-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-qr-code-line' />
          <div className='label'>ri-qr-code-line</div>
        </div>
        <div className='icon'>
          <i className='ri-qr-scan-2-fill' />
          <div className='label'>ri-qr-scan-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-qr-scan-2-line' />
          <div className='label'>ri-qr-scan-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-qr-scan-fill' />
          <div className='label'>ri-qr-scan-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-qr-scan-line' />
          <div className='label'>ri-qr-scan-line</div>
        </div>
        <div className='icon'>
          <i className='ri-question-answer-fill' />
          <div className='label'>ri-question-answer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-question-answer-line' />
          <div className='label'>ri-question-answer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-question-fill' />
          <div className='label'>ri-question-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-question-line' />
          <div className='label'>ri-question-line</div>
        </div>
        <div className='icon'>
          <i className='ri-question-mark' />
          <div className='label'>ri-question-mark</div>
        </div>
        <div className='icon'>
          <i className='ri-questionnaire-fill' />
          <div className='label'>ri-questionnaire-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-questionnaire-line' />
          <div className='label'>ri-questionnaire-line</div>
        </div>
        <div className='icon'>
          <i className='ri-quill-pen-fill' />
          <div className='label'>ri-quill-pen-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-quill-pen-line' />
          <div className='label'>ri-quill-pen-line</div>
        </div>
        <div className='icon'>
          <i className='ri-radar-fill' />
          <div className='label'>ri-radar-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-radar-line' />
          <div className='label'>ri-radar-line</div>
        </div>
        <div className='icon'>
          <i className='ri-radio-2-fill' />
          <div className='label'>ri-radio-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-radio-2-line' />
          <div className='label'>ri-radio-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-radio-button-fill' />
          <div className='label'>ri-radio-button-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-radio-button-line' />
          <div className='label'>ri-radio-button-line</div>
        </div>
        <div className='icon'>
          <i className='ri-radio-fill' />
          <div className='label'>ri-radio-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-radio-line' />
          <div className='label'>ri-radio-line</div>
        </div>
        <div className='icon'>
          <i className='ri-rainbow-fill' />
          <div className='label'>ri-rainbow-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-rainbow-line' />
          <div className='label'>ri-rainbow-line</div>
        </div>
        <div className='icon'>
          <i className='ri-rainy-fill' />
          <div className='label'>ri-rainy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-rainy-line' />
          <div className='label'>ri-rainy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-reactjs-fill' />
          <div className='label'>ri-reactjs-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-reactjs-line' />
          <div className='label'>ri-reactjs-line</div>
        </div>
        <div className='icon'>
          <i className='ri-record-circle-fill' />
          <div className='label'>ri-record-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-record-circle-line' />
          <div className='label'>ri-record-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-record-mail-fill' />
          <div className='label'>ri-record-mail-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-record-mail-line' />
          <div className='label'>ri-record-mail-line</div>
        </div>
        <div className='icon'>
          <i className='ri-recycle-fill' />
          <div className='label'>ri-recycle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-recycle-line' />
          <div className='label'>ri-recycle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-red-packet-fill' />
          <div className='label'>ri-red-packet-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-red-packet-line' />
          <div className='label'>ri-red-packet-line</div>
        </div>
        <div className='icon'>
          <i className='ri-reddit-fill' />
          <div className='label'>ri-reddit-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-reddit-line' />
          <div className='label'>ri-reddit-line</div>
        </div>
        <div className='icon'>
          <i className='ri-refresh-fill' />
          <div className='label'>ri-refresh-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-refresh-line' />
          <div className='label'>ri-refresh-line</div>
        </div>
        <div className='icon'>
          <i className='ri-refund-2-fill' />
          <div className='label'>ri-refund-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-refund-2-line' />
          <div className='label'>ri-refund-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-refund-fill' />
          <div className='label'>ri-refund-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-refund-line' />
          <div className='label'>ri-refund-line</div>
        </div>
        <div className='icon'>
          <i className='ri-registered-fill' />
          <div className='label'>ri-registered-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-registered-line' />
          <div className='label'>ri-registered-line</div>
        </div>
        <div className='icon'>
          <i className='ri-remixicon-fill' />
          <div className='label'>ri-remixicon-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-remixicon-line' />
          <div className='label'>ri-remixicon-line</div>
        </div>
        <div className='icon'>
          <i className='ri-remote-control-2-fill' />
          <div className='label'>ri-remote-control-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-remote-control-2-line' />
          <div className='label'>ri-remote-control-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-remote-control-fill' />
          <div className='label'>ri-remote-control-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-remote-control-line' />
          <div className='label'>ri-remote-control-line</div>
        </div>
        <div className='icon'>
          <i className='ri-repeat-2-fill' />
          <div className='label'>ri-repeat-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-repeat-2-line' />
          <div className='label'>ri-repeat-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-repeat-fill' />
          <div className='label'>ri-repeat-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-repeat-line' />
          <div className='label'>ri-repeat-line</div>
        </div>
        <div className='icon'>
          <i className='ri-repeat-one-fill' />
          <div className='label'>ri-repeat-one-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-repeat-one-line' />
          <div className='label'>ri-repeat-one-line</div>
        </div>
        <div className='icon'>
          <i className='ri-reply-all-fill' />
          <div className='label'>ri-reply-all-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-reply-all-line' />
          <div className='label'>ri-reply-all-line</div>
        </div>
        <div className='icon'>
          <i className='ri-reply-fill' />
          <div className='label'>ri-reply-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-reply-line' />
          <div className='label'>ri-reply-line</div>
        </div>
        <div className='icon'>
          <i className='ri-reserved-fill' />
          <div className='label'>ri-reserved-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-reserved-line' />
          <div className='label'>ri-reserved-line</div>
        </div>
        <div className='icon'>
          <i className='ri-rest-time-fill' />
          <div className='label'>ri-rest-time-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-rest-time-line' />
          <div className='label'>ri-rest-time-line</div>
        </div>
        <div className='icon'>
          <i className='ri-restart-fill' />
          <div className='label'>ri-restart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-restart-line' />
          <div className='label'>ri-restart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-restaurant-2-fill' />
          <div className='label'>ri-restaurant-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-restaurant-2-line' />
          <div className='label'>ri-restaurant-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-restaurant-fill' />
          <div className='label'>ri-restaurant-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-restaurant-line' />
          <div className='label'>ri-restaurant-line</div>
        </div>
        <div className='icon'>
          <i className='ri-rewind-fill' />
          <div className='label'>ri-rewind-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-rewind-line' />
          <div className='label'>ri-rewind-line</div>
        </div>
        <div className='icon'>
          <i className='ri-rewind-mini-fill' />
          <div className='label'>ri-rewind-mini-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-rewind-mini-line' />
          <div className='label'>ri-rewind-mini-line</div>
        </div>
        <div className='icon'>
          <i className='ri-rhythm-fill' />
          <div className='label'>ri-rhythm-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-rhythm-line' />
          <div className='label'>ri-rhythm-line</div>
        </div>
        <div className='icon'>
          <i className='ri-riding-fill' />
          <div className='label'>ri-riding-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-riding-line' />
          <div className='label'>ri-riding-line</div>
        </div>
        <div className='icon'>
          <i className='ri-road-map-fill' />
          <div className='label'>ri-road-map-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-road-map-line' />
          <div className='label'>ri-road-map-line</div>
        </div>
        <div className='icon'>
          <i className='ri-roadster-fill' />
          <div className='label'>ri-roadster-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-roadster-line' />
          <div className='label'>ri-roadster-line</div>
        </div>
        <div className='icon'>
          <i className='ri-robot-fill' />
          <div className='label'>ri-robot-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-robot-line' />
          <div className='label'>ri-robot-line</div>
        </div>
        <div className='icon'>
          <i className='ri-rocket-2-fill' />
          <div className='label'>ri-rocket-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-rocket-2-line' />
          <div className='label'>ri-rocket-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-rocket-fill' />
          <div className='label'>ri-rocket-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-rocket-line' />
          <div className='label'>ri-rocket-line</div>
        </div>
        <div className='icon'>
          <i className='ri-rotate-lock-fill' />
          <div className='label'>ri-rotate-lock-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-rotate-lock-line' />
          <div className='label'>ri-rotate-lock-line</div>
        </div>
        <div className='icon'>
          <i className='ri-rounded-corner' />
          <div className='label'>ri-rounded-corner</div>
        </div>
        <div className='icon'>
          <i className='ri-route-fill' />
          <div className='label'>ri-route-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-route-line' />
          <div className='label'>ri-route-line</div>
        </div>
        <div className='icon'>
          <i className='ri-router-fill' />
          <div className='label'>ri-router-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-router-line' />
          <div className='label'>ri-router-line</div>
        </div>
        <div className='icon'>
          <i className='ri-rss-fill' />
          <div className='label'>ri-rss-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-rss-line' />
          <div className='label'>ri-rss-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ruler-2-fill' />
          <div className='label'>ri-ruler-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ruler-2-line' />
          <div className='label'>ri-ruler-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ruler-fill' />
          <div className='label'>ri-ruler-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ruler-line' />
          <div className='label'>ri-ruler-line</div>
        </div>
        <div className='icon'>
          <i className='ri-run-fill' />
          <div className='label'>ri-run-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-run-line' />
          <div className='label'>ri-run-line</div>
        </div>
        <div className='icon'>
          <i className='ri-safari-fill' />
          <div className='label'>ri-safari-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-safari-line' />
          <div className='label'>ri-safari-line</div>
        </div>
        <div className='icon'>
          <i className='ri-safe-2-fill' />
          <div className='label'>ri-safe-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-safe-2-line' />
          <div className='label'>ri-safe-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-safe-fill' />
          <div className='label'>ri-safe-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-safe-line' />
          <div className='label'>ri-safe-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sailboat-fill' />
          <div className='label'>ri-sailboat-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sailboat-line' />
          <div className='label'>ri-sailboat-line</div>
        </div>
        <div className='icon'>
          <i className='ri-save-2-fill' />
          <div className='label'>ri-save-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-save-2-line' />
          <div className='label'>ri-save-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-save-3-fill' />
          <div className='label'>ri-save-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-save-3-line' />
          <div className='label'>ri-save-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-save-fill' />
          <div className='label'>ri-save-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-save-line' />
          <div className='label'>ri-save-line</div>
        </div>
        <div className='icon'>
          <i className='ri-scales-2-fill' />
          <div className='label'>ri-scales-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-scales-2-line' />
          <div className='label'>ri-scales-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-scales-3-fill' />
          <div className='label'>ri-scales-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-scales-3-line' />
          <div className='label'>ri-scales-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-scales-fill' />
          <div className='label'>ri-scales-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-scales-line' />
          <div className='label'>ri-scales-line</div>
        </div>
        <div className='icon'>
          <i className='ri-scan-2-fill' />
          <div className='label'>ri-scan-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-scan-2-line' />
          <div className='label'>ri-scan-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-scan-fill' />
          <div className='label'>ri-scan-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-scan-line' />
          <div className='label'>ri-scan-line</div>
        </div>
        <div className='icon'>
          <i className='ri-scissors-2-fill' />
          <div className='label'>ri-scissors-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-scissors-2-line' />
          <div className='label'>ri-scissors-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-scissors-cut-fill' />
          <div className='label'>ri-scissors-cut-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-scissors-cut-line' />
          <div className='label'>ri-scissors-cut-line</div>
        </div>
        <div className='icon'>
          <i className='ri-scissors-fill' />
          <div className='label'>ri-scissors-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-scissors-line' />
          <div className='label'>ri-scissors-line</div>
        </div>
        <div className='icon'>
          <i className='ri-screenshot-2-fill' />
          <div className='label'>ri-screenshot-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-screenshot-2-line' />
          <div className='label'>ri-screenshot-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-screenshot-fill' />
          <div className='label'>ri-screenshot-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-screenshot-line' />
          <div className='label'>ri-screenshot-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sd-card-fill' />
          <div className='label'>ri-sd-card-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sd-card-line' />
          <div className='label'>ri-sd-card-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sd-card-mini-fill' />
          <div className='label'>ri-sd-card-mini-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sd-card-mini-line' />
          <div className='label'>ri-sd-card-mini-line</div>
        </div>
        <div className='icon'>
          <i className='ri-search-2-fill' />
          <div className='label'>ri-search-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-search-2-line' />
          <div className='label'>ri-search-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-search-eye-fill' />
          <div className='label'>ri-search-eye-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-search-eye-line' />
          <div className='label'>ri-search-eye-line</div>
        </div>
        <div className='icon'>
          <i className='ri-search-fill' />
          <div className='label'>ri-search-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-search-line' />
          <div className='label'>ri-search-line</div>
        </div>
        <div className='icon'>
          <i className='ri-secure-payment-fill' />
          <div className='label'>ri-secure-payment-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-secure-payment-line' />
          <div className='label'>ri-secure-payment-line</div>
        </div>
        <div className='icon'>
          <i className='ri-seedling-fill' />
          <div className='label'>ri-seedling-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-seedling-line' />
          <div className='label'>ri-seedling-line</div>
        </div>
        <div className='icon'>
          <i className='ri-send-backward' />
          <div className='label'>ri-send-backward</div>
        </div>
        <div className='icon'>
          <i className='ri-send-plane-2-fill' />
          <div className='label'>ri-send-plane-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-send-plane-2-line' />
          <div className='label'>ri-send-plane-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-send-plane-fill' />
          <div className='label'>ri-send-plane-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-send-plane-line' />
          <div className='label'>ri-send-plane-line</div>
        </div>
        <div className='icon'>
          <i className='ri-send-to-back' />
          <div className='label'>ri-send-to-back</div>
        </div>
        <div className='icon'>
          <i className='ri-sensor-fill' />
          <div className='label'>ri-sensor-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sensor-line' />
          <div className='label'>ri-sensor-line</div>
        </div>
        <div className='icon'>
          <i className='ri-separator' />
          <div className='label'>ri-separator</div>
        </div>
        <div className='icon'>
          <i className='ri-server-fill' />
          <div className='label'>ri-server-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-server-line' />
          <div className='label'>ri-server-line</div>
        </div>
        <div className='icon'>
          <i className='ri-service-fill' />
          <div className='label'>ri-service-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-service-line' />
          <div className='label'>ri-service-line</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-2-fill' />
          <div className='label'>ri-settings-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-2-line' />
          <div className='label'>ri-settings-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-3-fill' />
          <div className='label'>ri-settings-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-3-line' />
          <div className='label'>ri-settings-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-4-fill' />
          <div className='label'>ri-settings-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-4-line' />
          <div className='label'>ri-settings-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-5-fill' />
          <div className='label'>ri-settings-5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-5-line' />
          <div className='label'>ri-settings-5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-6-fill' />
          <div className='label'>ri-settings-6-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-6-line' />
          <div className='label'>ri-settings-6-line</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-fill' />
          <div className='label'>ri-settings-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-settings-line' />
          <div className='label'>ri-settings-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shape-2-fill' />
          <div className='label'>ri-shape-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shape-2-line' />
          <div className='label'>ri-shape-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shape-fill' />
          <div className='label'>ri-shape-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shape-line' />
          <div className='label'>ri-shape-line</div>
        </div>
        <div className='icon'>
          <i className='ri-share-box-fill' />
          <div className='label'>ri-share-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-share-box-line' />
          <div className='label'>ri-share-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-share-circle-fill' />
          <div className='label'>ri-share-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-share-circle-line' />
          <div className='label'>ri-share-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-share-fill' />
          <div className='label'>ri-share-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-share-forward-2-fill' />
          <div className='label'>ri-share-forward-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-share-forward-2-line' />
          <div className='label'>ri-share-forward-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-share-forward-box-fill' />
          <div className='label'>ri-share-forward-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-share-forward-box-line' />
          <div className='label'>ri-share-forward-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-share-forward-fill' />
          <div className='label'>ri-share-forward-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-share-forward-line' />
          <div className='label'>ri-share-forward-line</div>
        </div>
        <div className='icon'>
          <i className='ri-share-line' />
          <div className='label'>ri-share-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-check-fill' />
          <div className='label'>ri-shield-check-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-check-line' />
          <div className='label'>ri-shield-check-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-cross-fill' />
          <div className='label'>ri-shield-cross-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-cross-line' />
          <div className='label'>ri-shield-cross-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-fill' />
          <div className='label'>ri-shield-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-flash-fill' />
          <div className='label'>ri-shield-flash-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-flash-line' />
          <div className='label'>ri-shield-flash-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-keyhole-fill' />
          <div className='label'>ri-shield-keyhole-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-keyhole-line' />
          <div className='label'>ri-shield-keyhole-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-line' />
          <div className='label'>ri-shield-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-star-fill' />
          <div className='label'>ri-shield-star-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-star-line' />
          <div className='label'>ri-shield-star-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-user-fill' />
          <div className='label'>ri-shield-user-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shield-user-line' />
          <div className='label'>ri-shield-user-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ship-2-fill' />
          <div className='label'>ri-ship-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ship-2-line' />
          <div className='label'>ri-ship-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ship-fill' />
          <div className='label'>ri-ship-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ship-line' />
          <div className='label'>ri-ship-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shirt-fill' />
          <div className='label'>ri-shirt-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shirt-line' />
          <div className='label'>ri-shirt-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-bag-2-fill' />
          <div className='label'>ri-shopping-bag-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-bag-2-line' />
          <div className='label'>ri-shopping-bag-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-bag-3-fill' />
          <div className='label'>ri-shopping-bag-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-bag-3-line' />
          <div className='label'>ri-shopping-bag-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-bag-fill' />
          <div className='label'>ri-shopping-bag-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-bag-line' />
          <div className='label'>ri-shopping-bag-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-basket-2-fill' />
          <div className='label'>ri-shopping-basket-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-basket-2-line' />
          <div className='label'>ri-shopping-basket-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-basket-fill' />
          <div className='label'>ri-shopping-basket-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-basket-line' />
          <div className='label'>ri-shopping-basket-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-cart-2-fill' />
          <div className='label'>ri-shopping-cart-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-cart-2-line' />
          <div className='label'>ri-shopping-cart-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-cart-fill' />
          <div className='label'>ri-shopping-cart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shopping-cart-line' />
          <div className='label'>ri-shopping-cart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-showers-fill' />
          <div className='label'>ri-showers-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-showers-line' />
          <div className='label'>ri-showers-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shuffle-fill' />
          <div className='label'>ri-shuffle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shuffle-line' />
          <div className='label'>ri-shuffle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-shut-down-fill' />
          <div className='label'>ri-shut-down-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-shut-down-line' />
          <div className='label'>ri-shut-down-line</div>
        </div>
        <div className='icon'>
          <i className='ri-side-bar-fill' />
          <div className='label'>ri-side-bar-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-side-bar-line' />
          <div className='label'>ri-side-bar-line</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-tower-fill' />
          <div className='label'>ri-signal-tower-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-tower-line' />
          <div className='label'>ri-signal-tower-line</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-1-fill' />
          <div className='label'>ri-signal-wifi-1-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-1-line' />
          <div className='label'>ri-signal-wifi-1-line</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-2-fill' />
          <div className='label'>ri-signal-wifi-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-2-line' />
          <div className='label'>ri-signal-wifi-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-3-fill' />
          <div className='label'>ri-signal-wifi-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-3-line' />
          <div className='label'>ri-signal-wifi-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-error-fill' />
          <div className='label'>ri-signal-wifi-error-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-error-line' />
          <div className='label'>ri-signal-wifi-error-line</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-fill' />
          <div className='label'>ri-signal-wifi-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-line' />
          <div className='label'>ri-signal-wifi-line</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-off-fill' />
          <div className='label'>ri-signal-wifi-off-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-signal-wifi-off-line' />
          <div className='label'>ri-signal-wifi-off-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sim-card-2-fill' />
          <div className='label'>ri-sim-card-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sim-card-2-line' />
          <div className='label'>ri-sim-card-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sim-card-fill' />
          <div className='label'>ri-sim-card-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sim-card-line' />
          <div className='label'>ri-sim-card-line</div>
        </div>
        <div className='icon'>
          <i className='ri-single-quotes-l' />
          <div className='label'>ri-single-quotes-l</div>
        </div>
        <div className='icon'>
          <i className='ri-single-quotes-r' />
          <div className='label'>ri-single-quotes-r</div>
        </div>
        <div className='icon'>
          <i className='ri-sip-fill' />
          <div className='label'>ri-sip-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sip-line' />
          <div className='label'>ri-sip-line</div>
        </div>
        <div className='icon'>
          <i className='ri-skip-back-fill' />
          <div className='label'>ri-skip-back-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-skip-back-line' />
          <div className='label'>ri-skip-back-line</div>
        </div>
        <div className='icon'>
          <i className='ri-skip-back-mini-fill' />
          <div className='label'>ri-skip-back-mini-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-skip-back-mini-line' />
          <div className='label'>ri-skip-back-mini-line</div>
        </div>
        <div className='icon'>
          <i className='ri-skip-forward-fill' />
          <div className='label'>ri-skip-forward-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-skip-forward-line' />
          <div className='label'>ri-skip-forward-line</div>
        </div>
        <div className='icon'>
          <i className='ri-skip-forward-mini-fill' />
          <div className='label'>ri-skip-forward-mini-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-skip-forward-mini-line' />
          <div className='label'>ri-skip-forward-mini-line</div>
        </div>
        <div className='icon'>
          <i className='ri-skull-2-fill' />
          <div className='label'>ri-skull-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-skull-2-line' />
          <div className='label'>ri-skull-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-skull-fill' />
          <div className='label'>ri-skull-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-skull-line' />
          <div className='label'>ri-skull-line</div>
        </div>
        <div className='icon'>
          <i className='ri-skype-fill' />
          <div className='label'>ri-skype-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-skype-line' />
          <div className='label'>ri-skype-line</div>
        </div>
        <div className='icon'>
          <i className='ri-slack-fill' />
          <div className='label'>ri-slack-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-slack-line' />
          <div className='label'>ri-slack-line</div>
        </div>
        <div className='icon'>
          <i className='ri-slice-fill' />
          <div className='label'>ri-slice-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-slice-line' />
          <div className='label'>ri-slice-line</div>
        </div>
        <div className='icon'>
          <i className='ri-slideshow-2-fill' />
          <div className='label'>ri-slideshow-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-slideshow-2-line' />
          <div className='label'>ri-slideshow-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-slideshow-3-fill' />
          <div className='label'>ri-slideshow-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-slideshow-3-line' />
          <div className='label'>ri-slideshow-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-slideshow-4-fill' />
          <div className='label'>ri-slideshow-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-slideshow-4-line' />
          <div className='label'>ri-slideshow-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-slideshow-fill' />
          <div className='label'>ri-slideshow-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-slideshow-line' />
          <div className='label'>ri-slideshow-line</div>
        </div>
        <div className='icon'>
          <i className='ri-smartphone-fill' />
          <div className='label'>ri-smartphone-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-smartphone-line' />
          <div className='label'>ri-smartphone-line</div>
        </div>
        <div className='icon'>
          <i className='ri-snapchat-fill' />
          <div className='label'>ri-snapchat-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-snapchat-line' />
          <div className='label'>ri-snapchat-line</div>
        </div>
        <div className='icon'>
          <i className='ri-snowy-fill' />
          <div className='label'>ri-snowy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-snowy-line' />
          <div className='label'>ri-snowy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sort-asc' />
          <div className='label'>ri-sort-asc</div>
        </div>
        <div className='icon'>
          <i className='ri-sort-desc' />
          <div className='label'>ri-sort-desc</div>
        </div>
        <div className='icon'>
          <i className='ri-sound-module-fill' />
          <div className='label'>ri-sound-module-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sound-module-line' />
          <div className='label'>ri-sound-module-line</div>
        </div>
        <div className='icon'>
          <i className='ri-soundcloud-fill' />
          <div className='label'>ri-soundcloud-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-soundcloud-line' />
          <div className='label'>ri-soundcloud-line</div>
        </div>
        <div className='icon'>
          <i className='ri-space-ship-fill' />
          <div className='label'>ri-space-ship-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-space-ship-line' />
          <div className='label'>ri-space-ship-line</div>
        </div>
        <div className='icon'>
          <i className='ri-space' />
          <div className='label'>ri-space</div>
        </div>
        <div className='icon'>
          <i className='ri-spam-2-fill' />
          <div className='label'>ri-spam-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-spam-2-line' />
          <div className='label'>ri-spam-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-spam-3-fill' />
          <div className='label'>ri-spam-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-spam-3-line' />
          <div className='label'>ri-spam-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-spam-fill' />
          <div className='label'>ri-spam-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-spam-line' />
          <div className='label'>ri-spam-line</div>
        </div>
        <div className='icon'>
          <i className='ri-speaker-2-fill' />
          <div className='label'>ri-speaker-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-speaker-2-line' />
          <div className='label'>ri-speaker-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-speaker-3-fill' />
          <div className='label'>ri-speaker-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-speaker-3-line' />
          <div className='label'>ri-speaker-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-speaker-fill' />
          <div className='label'>ri-speaker-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-speaker-line' />
          <div className='label'>ri-speaker-line</div>
        </div>
        <div className='icon'>
          <i className='ri-spectrum-fill' />
          <div className='label'>ri-spectrum-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-spectrum-line' />
          <div className='label'>ri-spectrum-line</div>
        </div>
        <div className='icon'>
          <i className='ri-speed-fill' />
          <div className='label'>ri-speed-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-speed-line' />
          <div className='label'>ri-speed-line</div>
        </div>
        <div className='icon'>
          <i className='ri-speed-mini-fill' />
          <div className='label'>ri-speed-mini-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-speed-mini-line' />
          <div className='label'>ri-speed-mini-line</div>
        </div>
        <div className='icon'>
          <i className='ri-split-cells-horizontal' />
          <div className='label'>ri-split-cells-horizontal</div>
        </div>
        <div className='icon'>
          <i className='ri-split-cells-vertical' />
          <div className='label'>ri-split-cells-vertical</div>
        </div>
        <div className='icon'>
          <i className='ri-spotify-fill' />
          <div className='label'>ri-spotify-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-spotify-line' />
          <div className='label'>ri-spotify-line</div>
        </div>
        <div className='icon'>
          <i className='ri-spy-fill' />
          <div className='label'>ri-spy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-spy-line' />
          <div className='label'>ri-spy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-stack-fill' />
          <div className='label'>ri-stack-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-stack-line' />
          <div className='label'>ri-stack-line</div>
        </div>
        <div className='icon'>
          <i className='ri-stack-overflow-fill' />
          <div className='label'>ri-stack-overflow-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-stack-overflow-line' />
          <div className='label'>ri-stack-overflow-line</div>
        </div>
        <div className='icon'>
          <i className='ri-stackshare-fill' />
          <div className='label'>ri-stackshare-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-stackshare-line' />
          <div className='label'>ri-stackshare-line</div>
        </div>
        <div className='icon'>
          <i className='ri-star-fill' />
          <div className='label'>ri-star-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-star-half-fill' />
          <div className='label'>ri-star-half-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-star-half-line' />
          <div className='label'>ri-star-half-line</div>
        </div>
        <div className='icon'>
          <i className='ri-star-half-s-fill' />
          <div className='label'>ri-star-half-s-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-star-half-s-line' />
          <div className='label'>ri-star-half-s-line</div>
        </div>
        <div className='icon'>
          <i className='ri-star-line' />
          <div className='label'>ri-star-line</div>
        </div>
        <div className='icon'>
          <i className='ri-star-s-fill' />
          <div className='label'>ri-star-s-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-star-s-line' />
          <div className='label'>ri-star-s-line</div>
        </div>
        <div className='icon'>
          <i className='ri-star-smile-fill' />
          <div className='label'>ri-star-smile-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-star-smile-line' />
          <div className='label'>ri-star-smile-line</div>
        </div>
        <div className='icon'>
          <i className='ri-steam-fill' />
          <div className='label'>ri-steam-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-steam-line' />
          <div className='label'>ri-steam-line</div>
        </div>
        <div className='icon'>
          <i className='ri-steering-2-fill' />
          <div className='label'>ri-steering-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-steering-2-line' />
          <div className='label'>ri-steering-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-steering-fill' />
          <div className='label'>ri-steering-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-steering-line' />
          <div className='label'>ri-steering-line</div>
        </div>
        <div className='icon'>
          <i className='ri-stethoscope-fill' />
          <div className='label'>ri-stethoscope-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-stethoscope-line' />
          <div className='label'>ri-stethoscope-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sticky-note-2-fill' />
          <div className='label'>ri-sticky-note-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sticky-note-2-line' />
          <div className='label'>ri-sticky-note-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sticky-note-fill' />
          <div className='label'>ri-sticky-note-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sticky-note-line' />
          <div className='label'>ri-sticky-note-line</div>
        </div>
        <div className='icon'>
          <i className='ri-stock-fill' />
          <div className='label'>ri-stock-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-stock-line' />
          <div className='label'>ri-stock-line</div>
        </div>
        <div className='icon'>
          <i className='ri-stop-circle-fill' />
          <div className='label'>ri-stop-circle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-stop-circle-line' />
          <div className='label'>ri-stop-circle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-stop-fill' />
          <div className='label'>ri-stop-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-stop-line' />
          <div className='label'>ri-stop-line</div>
        </div>
        <div className='icon'>
          <i className='ri-stop-mini-fill' />
          <div className='label'>ri-stop-mini-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-stop-mini-line' />
          <div className='label'>ri-stop-mini-line</div>
        </div>
        <div className='icon'>
          <i className='ri-store-2-fill' />
          <div className='label'>ri-store-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-store-2-line' />
          <div className='label'>ri-store-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-store-3-fill' />
          <div className='label'>ri-store-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-store-3-line' />
          <div className='label'>ri-store-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-store-fill' />
          <div className='label'>ri-store-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-store-line' />
          <div className='label'>ri-store-line</div>
        </div>
        <div className='icon'>
          <i className='ri-strikethrough-2' />
          <div className='label'>ri-strikethrough-2</div>
        </div>
        <div className='icon'>
          <i className='ri-strikethrough' />
          <div className='label'>ri-strikethrough</div>
        </div>
        <div className='icon'>
          <i className='ri-subscript-2' />
          <div className='label'>ri-subscript-2</div>
        </div>
        <div className='icon'>
          <i className='ri-subscript' />
          <div className='label'>ri-subscript</div>
        </div>
        <div className='icon'>
          <i className='ri-subtract-fill' />
          <div className='label'>ri-subtract-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-subtract-line' />
          <div className='label'>ri-subtract-line</div>
        </div>
        <div className='icon'>
          <i className='ri-subway-fill' />
          <div className='label'>ri-subway-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-subway-line' />
          <div className='label'>ri-subway-line</div>
        </div>
        <div className='icon'>
          <i className='ri-subway-wifi-fill' />
          <div className='label'>ri-subway-wifi-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-subway-wifi-line' />
          <div className='label'>ri-subway-wifi-line</div>
        </div>
        <div className='icon'>
          <i className='ri-suitcase-2-fill' />
          <div className='label'>ri-suitcase-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-suitcase-2-line' />
          <div className='label'>ri-suitcase-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-suitcase-3-fill' />
          <div className='label'>ri-suitcase-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-suitcase-3-line' />
          <div className='label'>ri-suitcase-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-suitcase-fill' />
          <div className='label'>ri-suitcase-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-suitcase-line' />
          <div className='label'>ri-suitcase-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sun-cloudy-fill' />
          <div className='label'>ri-sun-cloudy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sun-cloudy-line' />
          <div className='label'>ri-sun-cloudy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sun-fill' />
          <div className='label'>ri-sun-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sun-foggy-fill' />
          <div className='label'>ri-sun-foggy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sun-foggy-line' />
          <div className='label'>ri-sun-foggy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sun-line' />
          <div className='label'>ri-sun-line</div>
        </div>
        <div className='icon'>
          <i className='ri-superscript-2' />
          <div className='label'>ri-superscript-2</div>
        </div>
        <div className='icon'>
          <i className='ri-superscript' />
          <div className='label'>ri-superscript</div>
        </div>
        <div className='icon'>
          <i className='ri-surgical-mask-fill' />
          <div className='label'>ri-surgical-mask-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-surgical-mask-line' />
          <div className='label'>ri-surgical-mask-line</div>
        </div>
        <div className='icon'>
          <i className='ri-surround-sound-fill' />
          <div className='label'>ri-surround-sound-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-surround-sound-line' />
          <div className='label'>ri-surround-sound-line</div>
        </div>
        <div className='icon'>
          <i className='ri-survey-fill' />
          <div className='label'>ri-survey-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-survey-line' />
          <div className='label'>ri-survey-line</div>
        </div>
        <div className='icon'>
          <i className='ri-swap-box-fill' />
          <div className='label'>ri-swap-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-swap-box-line' />
          <div className='label'>ri-swap-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-swap-fill' />
          <div className='label'>ri-swap-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-swap-line' />
          <div className='label'>ri-swap-line</div>
        </div>
        <div className='icon'>
          <i className='ri-switch-fill' />
          <div className='label'>ri-switch-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-switch-line' />
          <div className='label'>ri-switch-line</div>
        </div>
        <div className='icon'>
          <i className='ri-sword-fill' />
          <div className='label'>ri-sword-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-sword-line' />
          <div className='label'>ri-sword-line</div>
        </div>
        <div className='icon'>
          <i className='ri-syringe-fill' />
          <div className='label'>ri-syringe-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-syringe-line' />
          <div className='label'>ri-syringe-line</div>
        </div>
        <div className='icon'>
          <i className='ri-t-box-fill' />
          <div className='label'>ri-t-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-t-box-line' />
          <div className='label'>ri-t-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-t-shirt-2-fill' />
          <div className='label'>ri-t-shirt-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-t-shirt-2-line' />
          <div className='label'>ri-t-shirt-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-t-shirt-air-fill' />
          <div className='label'>ri-t-shirt-air-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-t-shirt-air-line' />
          <div className='label'>ri-t-shirt-air-line</div>
        </div>
        <div className='icon'>
          <i className='ri-t-shirt-fill' />
          <div className='label'>ri-t-shirt-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-t-shirt-line' />
          <div className='label'>ri-t-shirt-line</div>
        </div>
        <div className='icon'>
          <i className='ri-table-2' />
          <div className='label'>ri-table-2</div>
        </div>
        <div className='icon'>
          <i className='ri-table-alt-fill' />
          <div className='label'>ri-table-alt-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-table-alt-line' />
          <div className='label'>ri-table-alt-line</div>
        </div>
        <div className='icon'>
          <i className='ri-table-fill' />
          <div className='label'>ri-table-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-table-line' />
          <div className='label'>ri-table-line</div>
        </div>
        <div className='icon'>
          <i className='ri-tablet-fill' />
          <div className='label'>ri-tablet-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-tablet-line' />
          <div className='label'>ri-tablet-line</div>
        </div>
        <div className='icon'>
          <i className='ri-takeaway-fill' />
          <div className='label'>ri-takeaway-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-takeaway-line' />
          <div className='label'>ri-takeaway-line</div>
        </div>
        <div className='icon'>
          <i className='ri-taobao-fill' />
          <div className='label'>ri-taobao-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-taobao-line' />
          <div className='label'>ri-taobao-line</div>
        </div>
        <div className='icon'>
          <i className='ri-tape-fill' />
          <div className='label'>ri-tape-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-tape-line' />
          <div className='label'>ri-tape-line</div>
        </div>
        <div className='icon'>
          <i className='ri-task-fill' />
          <div className='label'>ri-task-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-task-line' />
          <div className='label'>ri-task-line</div>
        </div>
        <div className='icon'>
          <i className='ri-taxi-fill' />
          <div className='label'>ri-taxi-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-taxi-line' />
          <div className='label'>ri-taxi-line</div>
        </div>
        <div className='icon'>
          <i className='ri-taxi-wifi-fill' />
          <div className='label'>ri-taxi-wifi-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-taxi-wifi-line' />
          <div className='label'>ri-taxi-wifi-line</div>
        </div>
        <div className='icon'>
          <i className='ri-team-fill' />
          <div className='label'>ri-team-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-team-line' />
          <div className='label'>ri-team-line</div>
        </div>
        <div className='icon'>
          <i className='ri-telegram-fill' />
          <div className='label'>ri-telegram-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-telegram-line' />
          <div className='label'>ri-telegram-line</div>
        </div>
        <div className='icon'>
          <i className='ri-temp-cold-fill' />
          <div className='label'>ri-temp-cold-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-temp-cold-line' />
          <div className='label'>ri-temp-cold-line</div>
        </div>
        <div className='icon'>
          <i className='ri-temp-hot-fill' />
          <div className='label'>ri-temp-hot-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-temp-hot-line' />
          <div className='label'>ri-temp-hot-line</div>
        </div>
        <div className='icon'>
          <i className='ri-terminal-box-fill' />
          <div className='label'>ri-terminal-box-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-terminal-box-line' />
          <div className='label'>ri-terminal-box-line</div>
        </div>
        <div className='icon'>
          <i className='ri-terminal-fill' />
          <div className='label'>ri-terminal-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-terminal-line' />
          <div className='label'>ri-terminal-line</div>
        </div>
        <div className='icon'>
          <i className='ri-terminal-window-fill' />
          <div className='label'>ri-terminal-window-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-terminal-window-line' />
          <div className='label'>ri-terminal-window-line</div>
        </div>
        <div className='icon'>
          <i className='ri-test-tube-fill' />
          <div className='label'>ri-test-tube-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-test-tube-line' />
          <div className='label'>ri-test-tube-line</div>
        </div>
        <div className='icon'>
          <i className='ri-text-direction-l' />
          <div className='label'>ri-text-direction-l</div>
        </div>
        <div className='icon'>
          <i className='ri-text-direction-r' />
          <div className='label'>ri-text-direction-r</div>
        </div>
        <div className='icon'>
          <i className='ri-text-spacing' />
          <div className='label'>ri-text-spacing</div>
        </div>
        <div className='icon'>
          <i className='ri-text-wrap' />
          <div className='label'>ri-text-wrap</div>
        </div>
        <div className='icon'>
          <i className='ri-text' />
          <div className='label'>ri-text</div>
        </div>
        <div className='icon'>
          <i className='ri-thermometer-fill' />
          <div className='label'>ri-thermometer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-thermometer-line' />
          <div className='label'>ri-thermometer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-thumb-down-fill' />
          <div className='label'>ri-thumb-down-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-thumb-down-line' />
          <div className='label'>ri-thumb-down-line</div>
        </div>
        <div className='icon'>
          <i className='ri-thumb-up-fill' />
          <div className='label'>ri-thumb-up-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-thumb-up-line' />
          <div className='label'>ri-thumb-up-line</div>
        </div>
        <div className='icon'>
          <i className='ri-thunderstorms-fill' />
          <div className='label'>ri-thunderstorms-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-thunderstorms-line' />
          <div className='label'>ri-thunderstorms-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ticket-2-fill' />
          <div className='label'>ri-ticket-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ticket-2-line' />
          <div className='label'>ri-ticket-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ticket-fill' />
          <div className='label'>ri-ticket-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ticket-line' />
          <div className='label'>ri-ticket-line</div>
        </div>
        <div className='icon'>
          <i className='ri-time-fill' />
          <div className='label'>ri-time-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-time-line' />
          <div className='label'>ri-time-line</div>
        </div>
        <div className='icon'>
          <i className='ri-timer-2-fill' />
          <div className='label'>ri-timer-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-timer-2-line' />
          <div className='label'>ri-timer-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-timer-fill' />
          <div className='label'>ri-timer-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-timer-flash-fill' />
          <div className='label'>ri-timer-flash-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-timer-flash-line' />
          <div className='label'>ri-timer-flash-line</div>
        </div>
        <div className='icon'>
          <i className='ri-timer-line' />
          <div className='label'>ri-timer-line</div>
        </div>
        <div className='icon'>
          <i className='ri-todo-fill' />
          <div className='label'>ri-todo-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-todo-line' />
          <div className='label'>ri-todo-line</div>
        </div>
        <div className='icon'>
          <i className='ri-toggle-fill' />
          <div className='label'>ri-toggle-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-toggle-line' />
          <div className='label'>ri-toggle-line</div>
        </div>
        <div className='icon'>
          <i className='ri-tools-fill' />
          <div className='label'>ri-tools-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-tools-line' />
          <div className='label'>ri-tools-line</div>
        </div>
        <div className='icon'>
          <i className='ri-tornado-fill' />
          <div className='label'>ri-tornado-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-tornado-line' />
          <div className='label'>ri-tornado-line</div>
        </div>
        <div className='icon'>
          <i className='ri-trademark-fill' />
          <div className='label'>ri-trademark-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-trademark-line' />
          <div className='label'>ri-trademark-line</div>
        </div>
        <div className='icon'>
          <i className='ri-traffic-light-fill' />
          <div className='label'>ri-traffic-light-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-traffic-light-line' />
          <div className='label'>ri-traffic-light-line</div>
        </div>
        <div className='icon'>
          <i className='ri-train-fill' />
          <div className='label'>ri-train-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-train-line' />
          <div className='label'>ri-train-line</div>
        </div>
        <div className='icon'>
          <i className='ri-train-wifi-fill' />
          <div className='label'>ri-train-wifi-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-train-wifi-line' />
          <div className='label'>ri-train-wifi-line</div>
        </div>
        <div className='icon'>
          <i className='ri-translate-2' />
          <div className='label'>ri-translate-2</div>
        </div>
        <div className='icon'>
          <i className='ri-translate' />
          <div className='label'>ri-translate</div>
        </div>
        <div className='icon'>
          <i className='ri-travesti-fill' />
          <div className='label'>ri-travesti-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-travesti-line' />
          <div className='label'>ri-travesti-line</div>
        </div>
        <div className='icon'>
          <i className='ri-treasure-map-fill' />
          <div className='label'>ri-treasure-map-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-treasure-map-line' />
          <div className='label'>ri-treasure-map-line</div>
        </div>
        <div className='icon'>
          <i className='ri-trello-fill' />
          <div className='label'>ri-trello-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-trello-line' />
          <div className='label'>ri-trello-line</div>
        </div>
        <div className='icon'>
          <i className='ri-trophy-fill' />
          <div className='label'>ri-trophy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-trophy-line' />
          <div className='label'>ri-trophy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-truck-fill' />
          <div className='label'>ri-truck-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-truck-line' />
          <div className='label'>ri-truck-line</div>
        </div>
        <div className='icon'>
          <i className='ri-tumblr-fill' />
          <div className='label'>ri-tumblr-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-tumblr-line' />
          <div className='label'>ri-tumblr-line</div>
        </div>
        <div className='icon'>
          <i className='ri-tv-2-fill' />
          <div className='label'>ri-tv-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-tv-2-line' />
          <div className='label'>ri-tv-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-tv-fill' />
          <div className='label'>ri-tv-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-tv-line' />
          <div className='label'>ri-tv-line</div>
        </div>
        <div className='icon'>
          <i className='ri-twitch-fill' />
          <div className='label'>ri-twitch-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-twitch-line' />
          <div className='label'>ri-twitch-line</div>
        </div>
        <div className='icon'>
          <i className='ri-twitter-fill' />
          <div className='label'>ri-twitter-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-twitter-line' />
          <div className='label'>ri-twitter-line</div>
        </div>
        <div className='icon'>
          <i className='ri-typhoon-fill' />
          <div className='label'>ri-typhoon-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-typhoon-line' />
          <div className='label'>ri-typhoon-line</div>
        </div>
        <div className='icon'>
          <i className='ri-u-disk-fill' />
          <div className='label'>ri-u-disk-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-u-disk-line' />
          <div className='label'>ri-u-disk-line</div>
        </div>
        <div className='icon'>
          <i className='ri-ubuntu-fill' />
          <div className='label'>ri-ubuntu-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-ubuntu-line' />
          <div className='label'>ri-ubuntu-line</div>
        </div>
        <div className='icon'>
          <i className='ri-umbrella-fill' />
          <div className='label'>ri-umbrella-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-umbrella-line' />
          <div className='label'>ri-umbrella-line</div>
        </div>
        <div className='icon'>
          <i className='ri-underline' />
          <div className='label'>ri-underline</div>
        </div>
        <div className='icon'>
          <i className='ri-uninstall-fill' />
          <div className='label'>ri-uninstall-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-uninstall-line' />
          <div className='label'>ri-uninstall-line</div>
        </div>
        <div className='icon'>
          <i className='ri-unsplash-fill' />
          <div className='label'>ri-unsplash-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-unsplash-line' />
          <div className='label'>ri-unsplash-line</div>
        </div>
        <div className='icon'>
          <i className='ri-upload-2-fill' />
          <div className='label'>ri-upload-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-upload-2-line' />
          <div className='label'>ri-upload-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-upload-cloud-2-fill' />
          <div className='label'>ri-upload-cloud-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-upload-cloud-2-line' />
          <div className='label'>ri-upload-cloud-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-upload-cloud-fill' />
          <div className='label'>ri-upload-cloud-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-upload-cloud-line' />
          <div className='label'>ri-upload-cloud-line</div>
        </div>
        <div className='icon'>
          <i className='ri-upload-fill' />
          <div className='label'>ri-upload-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-upload-line' />
          <div className='label'>ri-upload-line</div>
        </div>
        <div className='icon'>
          <i className='ri-usb-fill' />
          <div className='label'>ri-usb-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-usb-line' />
          <div className='label'>ri-usb-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-2-fill' />
          <div className='label'>ri-user-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-2-line' />
          <div className='label'>ri-user-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-3-fill' />
          <div className='label'>ri-user-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-3-line' />
          <div className='label'>ri-user-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-4-fill' />
          <div className='label'>ri-user-4-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-4-line' />
          <div className='label'>ri-user-4-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-5-fill' />
          <div className='label'>ri-user-5-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-5-line' />
          <div className='label'>ri-user-5-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-6-fill' />
          <div className='label'>ri-user-6-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-6-line' />
          <div className='label'>ri-user-6-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-add-fill' />
          <div className='label'>ri-user-add-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-add-line' />
          <div className='label'>ri-user-add-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-fill' />
          <div className='label'>ri-user-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-follow-fill' />
          <div className='label'>ri-user-follow-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-follow-line' />
          <div className='label'>ri-user-follow-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-heart-fill' />
          <div className='label'>ri-user-heart-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-heart-line' />
          <div className='label'>ri-user-heart-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-line' />
          <div className='label'>ri-user-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-location-fill' />
          <div className='label'>ri-user-location-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-location-line' />
          <div className='label'>ri-user-location-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-received-2-fill' />
          <div className='label'>ri-user-received-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-received-2-line' />
          <div className='label'>ri-user-received-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-received-fill' />
          <div className='label'>ri-user-received-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-received-line' />
          <div className='label'>ri-user-received-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-search-fill' />
          <div className='label'>ri-user-search-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-search-line' />
          <div className='label'>ri-user-search-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-settings-fill' />
          <div className='label'>ri-user-settings-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-settings-line' />
          <div className='label'>ri-user-settings-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-shared-2-fill' />
          <div className='label'>ri-user-shared-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-shared-2-line' />
          <div className='label'>ri-user-shared-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-shared-fill' />
          <div className='label'>ri-user-shared-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-shared-line' />
          <div className='label'>ri-user-shared-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-smile-fill' />
          <div className='label'>ri-user-smile-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-smile-line' />
          <div className='label'>ri-user-smile-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-star-fill' />
          <div className='label'>ri-user-star-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-star-line' />
          <div className='label'>ri-user-star-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-unfollow-fill' />
          <div className='label'>ri-user-unfollow-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-unfollow-line' />
          <div className='label'>ri-user-unfollow-line</div>
        </div>
        <div className='icon'>
          <i className='ri-user-voice-fill' />
          <div className='label'>ri-user-voice-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-user-voice-line' />
          <div className='label'>ri-user-voice-line</div>
        </div>
        <div className='icon'>
          <i className='ri-video-add-fill' />
          <div className='label'>ri-video-add-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-video-add-line' />
          <div className='label'>ri-video-add-line</div>
        </div>
        <div className='icon'>
          <i className='ri-video-chat-fill' />
          <div className='label'>ri-video-chat-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-video-chat-line' />
          <div className='label'>ri-video-chat-line</div>
        </div>
        <div className='icon'>
          <i className='ri-video-download-fill' />
          <div className='label'>ri-video-download-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-video-download-line' />
          <div className='label'>ri-video-download-line</div>
        </div>
        <div className='icon'>
          <i className='ri-video-fill' />
          <div className='label'>ri-video-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-video-line' />
          <div className='label'>ri-video-line</div>
        </div>
        <div className='icon'>
          <i className='ri-video-upload-fill' />
          <div className='label'>ri-video-upload-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-video-upload-line' />
          <div className='label'>ri-video-upload-line</div>
        </div>
        <div className='icon'>
          <i className='ri-vidicon-2-fill' />
          <div className='label'>ri-vidicon-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-vidicon-2-line' />
          <div className='label'>ri-vidicon-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-vidicon-fill' />
          <div className='label'>ri-vidicon-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-vidicon-line' />
          <div className='label'>ri-vidicon-line</div>
        </div>
        <div className='icon'>
          <i className='ri-vimeo-fill' />
          <div className='label'>ri-vimeo-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-vimeo-line' />
          <div className='label'>ri-vimeo-line</div>
        </div>
        <div className='icon'>
          <i className='ri-vip-crown-2-fill' />
          <div className='label'>ri-vip-crown-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-vip-crown-2-line' />
          <div className='label'>ri-vip-crown-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-vip-crown-fill' />
          <div className='label'>ri-vip-crown-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-vip-crown-line' />
          <div className='label'>ri-vip-crown-line</div>
        </div>
        <div className='icon'>
          <i className='ri-vip-diamond-fill' />
          <div className='label'>ri-vip-diamond-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-vip-diamond-line' />
          <div className='label'>ri-vip-diamond-line</div>
        </div>
        <div className='icon'>
          <i className='ri-vip-fill' />
          <div className='label'>ri-vip-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-vip-line' />
          <div className='label'>ri-vip-line</div>
        </div>
        <div className='icon'>
          <i className='ri-virus-fill' />
          <div className='label'>ri-virus-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-virus-line' />
          <div className='label'>ri-virus-line</div>
        </div>
        <div className='icon'>
          <i className='ri-visa-fill' />
          <div className='label'>ri-visa-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-visa-line' />
          <div className='label'>ri-visa-line</div>
        </div>
        <div className='icon'>
          <i className='ri-voice-recognition-fill' />
          <div className='label'>ri-voice-recognition-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-voice-recognition-line' />
          <div className='label'>ri-voice-recognition-line</div>
        </div>
        <div className='icon'>
          <i className='ri-voiceprint-fill' />
          <div className='label'>ri-voiceprint-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-voiceprint-line' />
          <div className='label'>ri-voiceprint-line</div>
        </div>
        <div className='icon'>
          <i className='ri-volume-down-fill' />
          <div className='label'>ri-volume-down-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-volume-down-line' />
          <div className='label'>ri-volume-down-line</div>
        </div>
        <div className='icon'>
          <i className='ri-volume-mute-fill' />
          <div className='label'>ri-volume-mute-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-volume-mute-line' />
          <div className='label'>ri-volume-mute-line</div>
        </div>
        <div className='icon'>
          <i className='ri-volume-off-vibrate-fill' />
          <div className='label'>ri-volume-off-vibrate-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-volume-off-vibrate-line' />
          <div className='label'>ri-volume-off-vibrate-line</div>
        </div>
        <div className='icon'>
          <i className='ri-volume-up-fill' />
          <div className='label'>ri-volume-up-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-volume-up-line' />
          <div className='label'>ri-volume-up-line</div>
        </div>
        <div className='icon'>
          <i className='ri-volume-vibrate-fill' />
          <div className='label'>ri-volume-vibrate-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-volume-vibrate-line' />
          <div className='label'>ri-volume-vibrate-line</div>
        </div>
        <div className='icon'>
          <i className='ri-vuejs-fill' />
          <div className='label'>ri-vuejs-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-vuejs-line' />
          <div className='label'>ri-vuejs-line</div>
        </div>
        <div className='icon'>
          <i className='ri-walk-fill' />
          <div className='label'>ri-walk-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-walk-line' />
          <div className='label'>ri-walk-line</div>
        </div>
        <div className='icon'>
          <i className='ri-wallet-2-fill' />
          <div className='label'>ri-wallet-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-wallet-2-line' />
          <div className='label'>ri-wallet-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-wallet-3-fill' />
          <div className='label'>ri-wallet-3-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-wallet-3-line' />
          <div className='label'>ri-wallet-3-line</div>
        </div>
        <div className='icon'>
          <i className='ri-wallet-fill' />
          <div className='label'>ri-wallet-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-wallet-line' />
          <div className='label'>ri-wallet-line</div>
        </div>
        <div className='icon'>
          <i className='ri-water-flash-fill' />
          <div className='label'>ri-water-flash-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-water-flash-line' />
          <div className='label'>ri-water-flash-line</div>
        </div>
        <div className='icon'>
          <i className='ri-webcam-fill' />
          <div className='label'>ri-webcam-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-webcam-line' />
          <div className='label'>ri-webcam-line</div>
        </div>
        <div className='icon'>
          <i className='ri-wechat-2-fill' />
          <div className='label'>ri-wechat-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-wechat-2-line' />
          <div className='label'>ri-wechat-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-wechat-fill' />
          <div className='label'>ri-wechat-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-wechat-line' />
          <div className='label'>ri-wechat-line</div>
        </div>
        <div className='icon'>
          <i className='ri-wechat-pay-fill' />
          <div className='label'>ri-wechat-pay-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-wechat-pay-line' />
          <div className='label'>ri-wechat-pay-line</div>
        </div>
        <div className='icon'>
          <i className='ri-weibo-fill' />
          <div className='label'>ri-weibo-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-weibo-line' />
          <div className='label'>ri-weibo-line</div>
        </div>
        <div className='icon'>
          <i className='ri-whatsapp-fill' />
          <div className='label'>ri-whatsapp-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-whatsapp-line' />
          <div className='label'>ri-whatsapp-line</div>
        </div>
        <div className='icon'>
          <i className='ri-wheelchair-fill' />
          <div className='label'>ri-wheelchair-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-wheelchair-line' />
          <div className='label'>ri-wheelchair-line</div>
        </div>
        <div className='icon'>
          <i className='ri-wifi-fill' />
          <div className='label'>ri-wifi-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-wifi-line' />
          <div className='label'>ri-wifi-line</div>
        </div>
        <div className='icon'>
          <i className='ri-wifi-off-fill' />
          <div className='label'>ri-wifi-off-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-wifi-off-line' />
          <div className='label'>ri-wifi-off-line</div>
        </div>
        <div className='icon'>
          <i className='ri-window-2-fill' />
          <div className='label'>ri-window-2-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-window-2-line' />
          <div className='label'>ri-window-2-line</div>
        </div>
        <div className='icon'>
          <i className='ri-window-fill' />
          <div className='label'>ri-window-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-window-line' />
          <div className='label'>ri-window-line</div>
        </div>
        <div className='icon'>
          <i className='ri-windows-fill' />
          <div className='label'>ri-windows-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-windows-line' />
          <div className='label'>ri-windows-line</div>
        </div>
        <div className='icon'>
          <i className='ri-windy-fill' />
          <div className='label'>ri-windy-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-windy-line' />
          <div className='label'>ri-windy-line</div>
        </div>
        <div className='icon'>
          <i className='ri-wireless-charging-fill' />
          <div className='label'>ri-wireless-charging-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-wireless-charging-line' />
          <div className='label'>ri-wireless-charging-line</div>
        </div>
        <div className='icon'>
          <i className='ri-women-fill' />
          <div className='label'>ri-women-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-women-line' />
          <div className='label'>ri-women-line</div>
        </div>
        <div className='icon'>
          <i className='ri-wubi-input' />
          <div className='label'>ri-wubi-input</div>
        </div>
        <div className='icon'>
          <i className='ri-xbox-fill' />
          <div className='label'>ri-xbox-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-xbox-line' />
          <div className='label'>ri-xbox-line</div>
        </div>
        <div className='icon'>
          <i className='ri-xing-fill' />
          <div className='label'>ri-xing-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-xing-line' />
          <div className='label'>ri-xing-line</div>
        </div>
        <div className='icon'>
          <i className='ri-youtube-fill' />
          <div className='label'>ri-youtube-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-youtube-line' />
          <div className='label'>ri-youtube-line</div>
        </div>
        <div className='icon'>
          <i className='ri-zcool-fill' />
          <div className='label'>ri-zcool-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-zcool-line' />
          <div className='label'>ri-zcool-line</div>
        </div>
        <div className='icon'>
          <i className='ri-zhihu-fill' />
          <div className='label'>ri-zhihu-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-zhihu-line' />
          <div className='label'>ri-zhihu-line</div>
        </div>
        <div className='icon'>
          <i className='ri-zoom-in-fill' />
          <div className='label'>ri-zoom-in-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-zoom-in-line' />
          <div className='label'>ri-zoom-in-line</div>
        </div>
        <div className='icon'>
          <i className='ri-zoom-out-fill' />
          <div className='label'>ri-zoom-out-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-zoom-out-line' />
          <div className='label'>ri-zoom-out-line</div>
        </div>
        <div className='icon'>
          <i className='ri-zzz-fill' />
          <div className='label'>ri-zzz-fill</div>
        </div>
        <div className='icon'>
          <i className='ri-zzz-line' />
          <div className='label'>ri-zzz-line</div>
        </div>
      </div>
    </section>
  );
};

export default RemixIconsInner;
